$xhr = "";
$xhrCount = '';
$ajax_call_stone_list_running = "No";
$stoneTotal = $pageCount = 0;
const API_URL = "https://console-shopify.ringbuilder.io/frontend.php";
const STONE_TYPES = ["labgrown", "natural"];
const collectionHandleDefault = 'bezel-setting-engagement-rings';
let isRingSelected = false;
let ringHandle = '';
let showMatchStonePair = false;

// 1x1 transparent gif. Grid cards use this until the real photo arrives so the
// "no image" graphic is not shown during the download.
const VDBRC_STONE_THUMB_BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

function vdbrcSetStoneThumbnailLoading($img, isLoading) {
    const wrapper = $img.closest('.aqcstone-product-image-wrapper');
    wrapper.toggleClass('is-media-loading', isLoading);
    wrapper.find('.aqc-media-loader').attr('aria-hidden', isLoading ? 'false' : 'true');
}

function vdbrcFinishStoneThumbnail($img, failed) {
    const imgEl = $img[0];
    if (failed && imgEl) {
        imgEl.onerror = null;
        imgEl.src = no_image_url;
    }
    vdbrcSetStoneThumbnailLoading($img, false);
}

// Load a diamond thumbnail with a single network request (no probe <img>).
function vdbrcLoadStoneThumbnail($img) {
    const imgTag = $img;
    const imgEl = imgTag[0];
    const dataSrc = vdbrcResolveStoneImageUrl(imgTag.attr('data-src'));

    if (!dataSrc || dataSrc === no_image_url) {
        imgTag.attr('src', no_image_url).show();
        vdbrcSetStoneThumbnailLoading(imgTag, false);
        return;
    }

    if (imgEl && imgEl.getAttribute('src') === dataSrc && imgEl.complete && imgEl.naturalWidth > 0) {
        vdbrcSetStoneThumbnailLoading(imgTag, false);
        return;
    }

    vdbrcSetStoneThumbnailLoading(imgTag, true);

    imgTag
        .off('error.vdbrcThumb load.vdbrcThumb')
        .one('load.vdbrcThumb', function () {
            if (this.naturalWidth > 0) {
                vdbrcFinishStoneThumbnail($(this), false);
            }
        })
        .one('error.vdbrcThumb', function () {
            vdbrcFinishStoneThumbnail($(this), true);
        })
        .attr('src', dataSrc)
        .show();

    if (imgEl && imgEl.complete && imgEl.naturalWidth > 0) {
        vdbrcFinishStoneThumbnail(imgTag, false);
    }
}

function vdbrcLoadVisibleStoneThumbnails(containerSelector) {
    $(`${containerSelector} img.vdbrc_stone_grid_thumbnail`).each(function () {
        vdbrcLoadStoneThumbnail($(this));
    });
}

function vdbrcSetStoneResultsLoading(isLoading) {
    const containers = $(
        '#vdbrc_stone_grid_view_container, #vdbrc_stone_list_view_body'
    );

    containers.each(function () {
        const container = $(this);
        if (isLoading) {
            const currentHeight = container.outerHeight();
            if (currentHeight > 0) {
                container.css('min-height', `${currentHeight}px`);
            }
            container.addClass('vdbrc-results-updating').attr('aria-busy', 'true');
        } else {
            container
                .removeClass('vdbrc-results-updating')
                .removeAttr('aria-busy')
                .css('min-height', '');
        }
    });
}

const stoneConfig = {
    labgrown: {
        action: "get_labgrown_list",
        shapeArray: labgrownShapeArray,
        clarityArray: labgrownClarityArray,
        colorArray: labgrownColorArray,
        cutArray: labgrownCutArray,
        polishArray: labgrownPolishArray,
        symmetryArray: labgrownSymmetryArray,
        labArray: labgronLabArray,
        default_min_carat: default_min_carat_labgrown,
        default_max_carat: default_max_carat_labgrown,
        default_min_price: default_min_price_labgrown,
        default_max_price: default_max_price_labgrown,
        default_min_depth: default_min_depth_labgrown,
        default_max_depth: default_max_depth_labgrown,
        default_min_table: default_min_table_labgrown,
        default_max_table: default_max_table_labgrown,
        default_min_ratio: default_min_ratio_labgrown,
        default_max_ratio: default_max_ratio_labgrown
    },
    natural: {
        action: "get_natural_list",
        shapeArray: naturalShapeArray,
        clarityArray: naturalClarityArray,
        colorArray: naturalColorArray,
        cutArray: naturalCutArray,
        polishArray: naturalPolishArray,
        symmetryArray: naturalSymmetryArray,
        labArray: naturalLabArray,
        default_min_carat: default_min_carat_natural,
        default_max_carat: default_max_carat_natural,
        default_min_price: default_min_price_natural,
        default_max_price: default_max_price_natural,
        default_min_depth: default_min_depth_natural,
        default_max_depth: default_max_depth_natural,
        default_min_table: default_min_table_natural,
        default_max_table: default_max_table_natural,
        default_min_ratio: default_min_ratio_natural,
        default_max_ratio: default_max_ratio_natural
    }
};
var sliderObjArray = [];
var comparedStones = [];
var stoneMap = {};

async function applyFilter() {
    await call_stone_again();
}
// Create debounced version ONCE
const applyFilterDebounced = debounce(async function () {
    await applyFilter();
}, 200);

$(document).ready(async function () {
    const params = new URLSearchParams(window.location.search);
    const queryString = params.toString();

    if (params.has('show_match_stone_pair') && params.get('show_match_stone_pair') == 'true') {
        showMatchStonePair = true;
        $("#vdbrc_stone_list_view_container").addClass('dual-active-list');
        $("#vdbrc_stone_grid_view_container").hide();
        $(".vdbrc_stone_view_type[data-layout='list_view']").trigger('click');
        $(".vdbrc_stone_view_type[data-layout='grid_view']").hide();
    }

    if (params.has('ring-handle') && params.get('ring-handle').trim() !== '') {
        ringHandle = params.get('ring-handle');
        isRingSelected = true;

        if(isRingSelected){
            let settingSelectedShape = params.get('shape') || '';
            if(settingSelectedShape != ''){
                $('.vdbrc_stone_shapes_container').hide();
            }
        }
    }

    let pushstate_string = window.top.location.href;
    const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];

    document.cookie = `vdbrc_stone_tab=${vdbrcStoneTab}`;
    pushstate_string = updateUrl(pushstate_string, 'diamond_type', vdbrcStoneTab);

    top.window.history.pushState({}, "", pushstate_string);

    deepLinkStone();
    syncFiltersFromCookies();

    if (isMobileDevice()) {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        $('body').addClass('vdbrc_is_mobile_device');

        if (/android/i.test(userAgent)) {
            $('body').addClass('is-android');
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('body').addClass('is-ios');
        } else {
            console.log('Neither Android nor iOS');
        }
    }

    //#region : Custom Range Slider
    const sliderConfig = [
        { key: "price", decimals: 2 },
        { key: "carat", decimals: 2 },
        { key: "ratio", decimals: 1 },
        { key: "depth", decimals: 1 },
        { key: "table", decimals: 1 }
    ];

    STONE_TYPES.forEach((type) => {
        sliderConfig.forEach(({ key, decimals }) => {

            const fromSliderId = `vdbrc_${key}_from_slider_${type}_web`;
            const toSliderId = `vdbrc_${key}_to_slider_${type}_web`;
            const fromInputId = `vdbrc_${key}_from_slider_input_${type}_web`;
            const toInputId = `vdbrc_${key}_to_slider_input_${type}_web`;

            const minClass = `.vdbrc_min_${key}_${type}_web`;
            const maxClass = `.vdbrc_max_${key}_${type}_web`;

            const cookieMin = `vdbrc_min_${key}`;
            const cookieMax = `vdbrc_max_${key}`;

            let sliderObj = new customRangeSlider(fromSliderId, toSliderId, fromInputId, toInputId, null, null, false, (from, to) => {
                const fromValue = parseFloat(from).toFixed(decimals);
                const toValue = parseFloat(to).toFixed(decimals);

                $(minClass).val(fromValue);
                $(maxClass).val(toValue);

                document.cookie = `${cookieMin}=${fromValue}`;
                document.cookie = `${cookieMax}=${toValue}`;

                applyFilterDebounced();
            });

            sliderObjArray.push(sliderObj);

            // ✅ Manual input change listener
            $(`#${fromInputId}, #${toInputId}`).on('change', function (e) {
                let fromVal = parseFloat($(`#${fromInputId}`).val()) || 0;
                let toVal = parseFloat($(`#${toInputId}`).val()) || 0;

                const minLimit = parseFloat($(`#${fromSliderId}`).attr('min')) || 0;
                const maxLimit = parseFloat($(`#${toSliderId}`).attr('max')) || 999999;

                fromVal = Math.max(minLimit, Math.min(fromVal, maxLimit));
                toVal = Math.max(minLimit, Math.min(toVal, maxLimit));

                if (fromVal > toVal) {
                    if ($(this).attr('id') === fromInputId) {
                        fromVal = toVal;
                    } else {
                        toVal = fromVal;
                    }
                }

                fromVal = parseFloat(fromVal).toFixed(decimals);
                toVal = parseFloat(toVal).toFixed(decimals);

                $(`#${fromInputId}`).val(fromVal);
                $(`#${toInputId}`).val(toVal);

                $(minClass).val(fromVal);
                $(maxClass).val(toVal);

                document.cookie = `${cookieMin}=${fromVal}`;
                document.cookie = `${cookieMax}=${toVal}`;

                // Sync slider
                if (sliderObj && typeof sliderObj.setValues === "function") {
                    sliderObj.setValues(fromVal, toVal);
                } else {
                    $(`#${fromSliderId}`).val(fromVal).trigger("input");
                    $(`#${toSliderId}`).val(toVal).trigger("input");
                }

                applyFilterDebounced();
            });
        });
    });
    //#endregion

    $('.vdbrc_stone_filter_sidebar').addClass('d-none');
    $('.vdbrc_stone_shapes_container').addClass('d-none');
    $(`#vdbrc_${vdbrcStoneTab}_filters`).removeClass('d-none');
    $(`.vdbrc_stone_shapes_container[data-stone-type=${vdbrcStoneTab}]`).removeClass('d-none');

    await call_stone_again();

    if (ringHandle !== '') {
        // Each card builds its own review URL in vdbrcStoneCompleteUrl(), so only
        // the label is updated here.
        $('.vdbrc_complete_my_ring_btn').removeClass('d-none');
        $('.vdbrc_add_to_cart_btn').hide();
    }

});

async function call_stone_again() {
    $ajax_call_stone_list_running = 'No';

    $(".vdbrc_stone_search_diamond_count").html('&hellip;');
    vdbrcSetStoneResultsLoading(true);

    $("#vdbrc_stone_page_number").val('1');

    await call_stone_list();
}
async function call_stone_list() {
    // If a call is already running, exit early
    if ($ajax_call_stone_list_running === "Yes") {
        console.log('API call already in progress, skipping...');
        return;
    }

    // Set flag to prevent concurrent calls
    $ajax_call_stone_list_running = "Yes";

    resetDeepLink();

    const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
    const page_number = $("#vdbrc_stone_page_number").val();

    if (Number($pageCount) > 0 && Number(page_number) > Number($pageCount)) {
        $ajax_call_stone_list_running = "No";
        return;
    } else if (Number($pageCount) == 0 && Number(page_number) > 1) {
        $ajax_call_stone_list_running = "No";
        return;
    }

    const sendData = new URLSearchParams();

    const {
        action,
        shapeArray = [],
        clarityArray = [],
        colorArray = [],
        cutArray = [],
        polishArray = [],
        symmetryArray = [],
        labArray = [],
        fancyColorArray = [],
        default_min_carat = '',
        default_max_carat = '',
        default_min_price = '',
        default_max_price = '',
        default_min_depth = '',
        default_max_depth = '',
        default_min_table = '',
        default_max_table = '',
        default_min_ratio = '',
        default_max_ratio = ''
    } = stoneConfig[vdbrcStoneTab];

    let pushstate_string = window.top.location.href;
    pushstate_string = updateUrl(pushstate_string, 'diamond_type', vdbrcStoneTab);

    const stoneTabView = getCookie("vdbrc_stone_tab_view");
    pushstate_string = updateUrl(pushstate_string, 'stone_view', stoneTabView);

    sendData.append("action", action);
    sendData.append("shop", shop);
    sendData.append("page_number", page_number);
    sendData.append("total_count", $stoneTotal);
    sendData.append("with_images", 'true');
    sendData.append("location_data_wrap", 'India');

    let pageNumber = parseInt(page_number, 10) + 1;
    $("#vdbrc_stone_page_number").val(pageNumber);

    //#region : Shape
    const vdbrcStoneShape = getCookie("vdbrc_shape");
    if (vdbrcStoneShape) {
        sendData.append("shape_data", vdbrcStoneShape);
        pushstate_string = updateUrl(pushstate_string, "shape", vdbrcStoneShape);
    } else {
        sendData.append("shape_data", shapeArray.join(","));
    }
    //#endregion

    //#region : Price
    const rate = market_currency !== shop_currency ? $market_currency_rate : $currency_rate;
    const addPriceData = (param, cookieName, rate, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const price = parseFloat(cookieValue * rate).toFixed(2);
            sendData.append(param, price);
            pushstate_string = updateUrl(pushstate_string, param, price);
        } else {
            sendData.append(param, parseFloat(defaultValue * rate).toFixed(2));
        }
    };
    addPriceData("min_price", "vdbrc_min_price", rate, default_min_price);
    addPriceData("max_price", "vdbrc_max_price", rate, default_max_price);
    //#endregion

    //#region : White Color
    const addColorData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const color = cookieValue.split(",");
            const color_to = color[0];
            const color_from = color[color.length - 1];
            pushstate_string = updateUrl(pushstate_string, "color_to", color_to);
            pushstate_string = updateUrl(pushstate_string, "color_from", color_from);
            sendData.append(param, `${color_to},${color_from}`);
        } else {
            pushstate_string = updateUrl(pushstate_string, "color_to", undefined);
            pushstate_string = updateUrl(pushstate_string, "color_from", undefined);
            const vdbrcStoneFancyColor = getCookie("vdbrc_fancy_color");

            if (!vdbrcStoneFancyColor || vdbrcIsWhiteFancyValue(vdbrcStoneFancyColor)) {
                const color_to = defaultValue[0];
                const color_from = defaultValue[defaultValue.length - 1];
                sendData.append(param, `${color_to},${color_from}`);
            }
        }
    };
    addColorData("color_data_wrap", "vdbrc_color_white", colorArray);
    //#endregion

    //#region : Fancy Color
    const vdbrcStoneFancyColor = getCookie("vdbrc_fancy_color");
    if (vdbrcStoneFancyColor && !vdbrcIsWhiteFancyValue(vdbrcStoneFancyColor)) {
        sendData.append("fcolor_data_wrap", vdbrcStoneFancyColor);
        pushstate_string = updateUrl(pushstate_string, "fancy_color", vdbrcStoneFancyColor);
    } else {
        pushstate_string = updateUrl(pushstate_string, "fancy_color", undefined);
    }
    //#endregion

    //#region : Carat
    const addCaratData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const carat = parseFloat(cookieValue).toFixed(2);
            sendData.append(param, carat);
            pushstate_string = updateUrl(pushstate_string, param, carat);
        } else {
            sendData.append(param, parseFloat(defaultValue).toFixed(2));
        }
    };
    addCaratData("carat_min", "vdbrc_min_carat", default_min_carat);
    addCaratData("carat_max", "vdbrc_max_carat", default_max_carat);
    //#endregion

    //#region : Clarity
    const addClarityData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const clarity = cookieValue.split(",");
            const clarity_to = clarity[0];
            const clarity_from = clarity[clarity.length - 1];
            pushstate_string = updateUrl(pushstate_string, "clarity_to", clarity_to);
            pushstate_string = updateUrl(pushstate_string, "clarity_from", clarity_from);
            sendData.append(param, `${clarity_to},${clarity_from}`);
        } else {
            pushstate_string = updateUrl(pushstate_string, "clarity_to", undefined);
            pushstate_string = updateUrl(pushstate_string, "clarity_from", undefined);
            const clarity_to = defaultValue[0];
            const clarity_from = defaultValue[defaultValue.length - 1];
            sendData.append(param, `${clarity_to},${clarity_from}`);
        }
    };
    addClarityData("clarity_data_wrap", "vdbrc_clarity", clarityArray);
    //#endregion

    //#region : Cut
    const addCutData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const cut = cookieValue.split(",");
            const cut_to = cut[0];
            const cut_from = cut[cut.length - 1];
            pushstate_string = updateUrl(pushstate_string, "cut_to", cut_to);
            pushstate_string = updateUrl(pushstate_string, "cut_from", cut_from);
            sendData.append(param, `${cut_to},${cut_from}`);
        } else {
            pushstate_string = updateUrl(pushstate_string, "cut_to", undefined);
            pushstate_string = updateUrl(pushstate_string, "cut_from", undefined);
            const cut_to = defaultValue[0];
            const cut_from = defaultValue[defaultValue.length - 1];
            sendData.append(param, `${cut_to},${cut_from}`);
        }
    };
    addCutData("cut_data_wrap", "vdbrc_cut", cutArray);
    //#endregion

    //#region : Polish
    const addPolishData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const polish = cookieValue.split(",");
            const polish_to = polish[0];
            const polish_from = polish[polish.length - 1];
            pushstate_string = updateUrl(pushstate_string, "polish_to", polish_to);
            pushstate_string = updateUrl(pushstate_string, "polish_from", polish_from);
            sendData.append(param, `${polish_to},${polish_from}`);
        } else {
            pushstate_string = updateUrl(pushstate_string, "polish_to", undefined);
            pushstate_string = updateUrl(pushstate_string, "polish_from", undefined);
            const polish_to = defaultValue[0];
            const polish_from = defaultValue[defaultValue.length - 1];
            sendData.append(param, `${polish_to},${polish_from}`);
        }
    };
    addPolishData("polish_data_wrap", "vdbrc_polish", polishArray);
    //#endregion

    //#region : Symmetry
    const addSymmetryData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const symmetry = cookieValue.split(",");
            const symmetry_to = symmetry[0];
            const symmetry_from = symmetry[symmetry.length - 1];
            pushstate_string = updateUrl(pushstate_string, "symmetry_to", symmetry_to);
            pushstate_string = updateUrl(pushstate_string, "symmetry_from", symmetry_from);
            sendData.append(param, `${symmetry_to},${symmetry_from}`);
        } else {
            pushstate_string = updateUrl(pushstate_string, "symmetry_to", undefined);
            pushstate_string = updateUrl(pushstate_string, "symmetry_from", undefined);
            const symmetry_to = defaultValue[0];
            const symmetry_from = defaultValue[defaultValue.length - 1];
            sendData.append(param, `${symmetry_to},${symmetry_from}`);
        }
    };
    addSymmetryData("symmetry_data_wrap", "vdbrc_symmetry", symmetryArray);
    //#endregion

    //#region : Lab ( Certificate )
    const vdbrcStoneLab = getCookie("vdbrc_lab");
    if (vdbrcStoneLab) {
        sendData.append("lab_data", vdbrcStoneLab);
        pushstate_string = updateUrl(pushstate_string, "lab", vdbrcStoneLab);
    } else {
        pushstate_string = updateUrl(pushstate_string, "lab", undefined);
        sendData.append("lab_data", labArray.join(","));
    }
    //#endregion

    //#region : Depth
    const addDepthData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const carat = parseFloat(cookieValue).toFixed(1);
            sendData.append(param, carat);
            pushstate_string = updateUrl(pushstate_string, param, carat);
        } else {
            sendData.append(param, parseFloat(defaultValue).toFixed(2));
        }
    };
    addDepthData("depth_min", "vdbrc_min_depth", default_min_depth);
    addDepthData("depth_max", "vdbrc_max_depth", default_max_depth);
    //#endregion

    //#region : Table
    const addTableData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const carat = parseFloat(cookieValue).toFixed(1);
            sendData.append(param, carat);
            pushstate_string = updateUrl(pushstate_string, param, carat);
        } else {
            sendData.append(param, parseFloat(defaultValue).toFixed(2));
        }
    };
    addTableData("table_min", "vdbrc_min_table", default_min_table);
    addTableData("table_max", "vdbrc_max_table", default_max_table);
    //#endregion

    //#region : Ratio
    const addRatioData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const carat = parseFloat(cookieValue).toFixed(1);
            sendData.append(param, carat);
            pushstate_string = updateUrl(pushstate_string, param, carat);
        } else {
            sendData.append(param, parseFloat(defaultValue).toFixed(2));
        }
    };
    addRatioData("meas_ratio_from", "vdbrc_min_ratio", default_min_ratio);
    addRatioData("meas_ratio_to", "vdbrc_max_ratio", default_max_ratio);
    //#endregion

    //#region : Sorting
    const addSortingData = (param, cookieName, defaultValue) => {
        const cookieValue = getCookie(cookieName);
        if (cookieValue) {
            const sorting = cookieValue;
            sendData.append("sorting", sorting);
            pushstate_string = updateUrl(pushstate_string, param, cookieValue);
        } /* else {
            sendData.append("sorting", defaultValue);
        } */
    };
    addSortingData("sorting", "vdbrc_sorting", defaultSorting);

    const sorting_field = $("#sorting_field").val();
    const sorting_seq = $("#sorting_seq").val();

    sendData.append("sorting_field", sorting_field);
    sendData.append("sorting_seq", sorting_seq);
    //#endregion

    if (showMatchStonePair) {
        sendData.append("show_match_stone_pair", "true");
    }

    top.window.history.pushState({}, "", pushstate_string);

    // Update HTML
    $("#vdbrc_list_loading").show();

    if (Number(page_number) == 1) {
        if ($xhrCount != undefined && $xhrCount != '') {
            $xhrCount.abort();
        }
        let pageSendData = sendData + '&only_count_fetch=yes';
        $xhrCount = $.post(API_URL, pageSendData, function (countResultData) {
            var countResultArray = JSON.parse(countResultData);
            if (countResultArray['total_count'] != undefined && countResultArray['total_count'] != null) {
                $stoneTotal = number_format(countResultArray['total_count']);
                document.cookie = "vdbrc_stone_count=" + $stoneTotal;
            }
            $pageCount = countResultArray['page_count'];

            $('.vdbrc_stone_list_header').toggle(
                !($stoneTotal == 0 || $stoneTotal == '0')
            );

            $(".vdbrc_stone_total_count").html($stoneTotal);
        });
    }

    try {
        $xhr = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {

                $("#vdbrc_list_loading").hide();
                const resultArray = JSON.parse(resultData);
                const mainData = resultArray?.main_data?.response?.body || {};
                const stoneArray = mainData.diamonds || [];

                if (resultArray !== undefined && stoneArray.length > 0) {
                    let list_html = '';
                    let grid_html = "";

                    // Page 1 replaces the rendered results, later pages are appended,
                    // so the map has to be reset and extended the same way. Clearing it
                    // on every page left compare and quick view without data for any
                    // card outside the most recently loaded page.
                    if (Number(page_number) === 1) {
                        stoneMap = {};
                    }

                    for (let stone of stoneArray) {
                        if (showMatchStonePair && stoneArray.length > 0) {
                            if (!stone[0].id) continue;
                            stoneMap[stone[0].id] = stone[0];

                            const isCompared = comparedStones.some(s => s.id === stone[0].id);

                            // Use helpers
                            list_html += getStoneListHtml(stone, isCompared);
                        } else {
                            if (!stone.id) continue;
                            stoneMap[stone.id] = stone;

                            const isCompared = comparedStones.some(s => s.id === stone.id);

                            // Use helpers
                            list_html += getStoneListHtml(stone, isCompared);
                            grid_html += getStoneGridHtml(stone, isCompared);
                        }
                    }

                    if (Number(page_number) === 1) {
                        $("#vdbrc_stone_list_view_body").html(list_html);
                        $("#vdbrc_stone_grid_view_container").html(grid_html);
                    } else {
                        $("#vdbrc_stone_list_view_body").append(list_html);
                        $("#vdbrc_stone_grid_view_container").append(grid_html);
                    }
                    $("#vdbrc_stone_list_view_container .img, #vdbrc_stone_grid_view_container .img").on("error", function () {
                        this.src = no_image_url;
                    });

                    let view_type = getCookie("vdbrc_stone_tab_view");
                    if (view_type === "grid_view") {
                        vdbrcLoadVisibleStoneThumbnails("#vdbrc_stone_grid_view_container");
                    }
                } else if (Number(page_number) === 1) {
                    const emptyMessage = '<div class="vdb-rb-no-diamond-found">No diamond found.</div>';
                    $("#vdbrc_stone_grid_view_container").html(emptyMessage);
                    $("#vdbrc_stone_list_view_body").html(emptyMessage);
                }

                resolve();
            }).fail((error) => {
                console.error('API call failed:', error);
                reject(error);
            });
        });
    } catch (error) {
        console.error('Error loading stones:', error);
    } finally {
        // Always reset flag, even on error
        $ajax_call_stone_list_running = "No";
        $("#vdbrc_list_loading").hide();
        vdbrcSetStoneResultsLoading(false);
    }
}

//#region : Infinite Scroll Pagination
const handleScroll = debounce(function () {
    const $wrapper = $(".vdbrc_content_wrapper");
    if ($wrapper.length === 0) return;

    const wrapperBottom = $wrapper.offset().top + $wrapper.height();
    const windowBottom = $(window).scrollTop() + $(window).height();

    // Trigger when user scrolls within 300px of the bottom of the content
    if (windowBottom >= wrapperBottom - 300) {
        call_stone_list();
    }
}, 200);

if (pagination_type == 'SCROLL') {
    $(window).scroll(handleScroll);
}
//#endregion

//#region : Stone Type Toggle - Lab Grown / Natural
$('body').on('click', '.vdbrc_stone_tab', async function () {
    var stoneType = $(this).data('stone-type');

    $('.vdbrc_stone_tab').removeClass('aqcstone-active').addClass('aqcstone-inactive');
    $(this).removeClass('aqcstone-inactive').addClass('aqcstone-active');

    let pushstate_string = window.top.location.href;
    pushstate_string = updateUrl(pushstate_string, 'diamond_type', stoneType);
    top.window.history.pushState({}, "", pushstate_string);

    document.cookie = `vdbrc_stone_tab=${stoneType}`;

    $('.vdbrc_stone_filter_sidebar').addClass('d-none');
    $('.vdbrc_stone_shapes_container').addClass('d-none');
    $(`#vdbrc_${stoneType}_filters`).removeClass('d-none');
    $(`.vdbrc_stone_shapes_container[data-stone-type=${stoneType}]`).removeClass('d-none');
    vdbrcRevealSelectedFancyColor();

    applyFilterDebounced();
});
//#endregion

//#region : Stone View Type Toggle - Stone List / Compare
$('body').on('click', '.vdbrc_view_tab', function () {
    var viewType = $(this).data('view');

    $('.vdbrc_view_tab').addClass('aqcstone-inactive');
    $(this).removeClass('aqcstone-inactive').addClass('aqcstone-active');

    if (viewType === 'stone_list') {
        $('.vdbrc_stone_data_container').show();
        $('.vdbrc_stone_compare_container').hide();
    } else {
        $('.vdbrc_stone_data_container').hide();
        $('.vdbrc_stone_compare_container').show();
    }
    document.cookie = `vdbrc_view_type=${viewType}`;

    let pushstate_string = window.top.location.href;
    pushstate_string = updateUrl(pushstate_string, 'view_type', viewType);
    top.window.history.pushState({}, "", pushstate_string);

});
//#endregion

//#region : Stone View Type Toggle - Grid / List
$('body').on('click', '.vdbrc_stone_view_type', function () {
    const clickedTab = $(this);
    const layout = clickedTab.data('layout');

    const layoutTabs = $('.aqcstone-layout-tab');
    const layoutContents = $('.vdbrc_stone_view_content');

    // Reset sorting all headers to default icon
    $("#sorting_field").val('');
    $("#sorting_seq").val('ASC');
    $('.vdbrc_sorting_th').removeClass('ph-caret-up ph-caret-down').addClass('ph-caret-up-down');
    $('.vdbrc_sorting_th').find('i').removeClass('ph-caret-up ph-caret-down').addClass('ph-caret-up-down');

    // Reset all tabs
    layoutTabs.removeClass('aqcstone-active').addClass('aqcstone-inactive');

    // Activate clicked tab
    clickedTab.addClass('aqcstone-active').removeClass('aqcstone-inactive');

    // Toggle view contents
    layoutContents.each(function () {
        const content = $(this);

        if (content.data('layout-content') === layout) {
            content.addClass('aqcstone-active').css('display', layout === 'grid_view' ? 'grid' : 'flex');
        } else {
            content.removeClass('aqcstone-active').css('display', 'none');
        }
    });
    document.cookie = `vdbrc_stone_tab_view=${layout}`;

    if (layout === 'grid_view') {
        vdbrcLoadVisibleStoneThumbnails("#vdbrc_stone_grid_view_container");
    }

    let pushstate_string = window.top.location.href;
    pushstate_string = updateUrl(pushstate_string, 'stone_view', layout);
    top.window.history.pushState({}, "", pushstate_string);
});
//#endregion

//#region : Filter Events
$('body').on('click', '.vdbrc_stone_shape', function () {
    const shapeValue = $(this).data('value');

    $('.vdbrc_stone_shape').removeClass('aqcstone-active');
    $(this).addClass('aqcstone-active');

    document.cookie = `vdbrc_shape=${shapeValue}`;
    applyFilterDebounced();
});

const vdbrcRangeFilterState = {
    color: { start: null, end: null, tab: null },
    clarity: { start: null, end: null, tab: null },
    cut: { start: null, end: null, tab: null },
    polish: { start: null, end: null, tab: null },
    symmetry: { start: null, end: null, tab: null }
};

function vdbrcCurrentStoneTab() {
    return getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
}

function vdbrcRangeOrder(orderKey) {
    const config = stoneConfig[vdbrcCurrentStoneTab()] || stoneConfig.labgrown;
    return ((config && config[orderKey]) || []).map(function (value) {
        return $.trim(String(value));
    }).filter(Boolean);
}

function vdbrcPaintRangeButtons(buttonClass, order, startIndex, endIndex) {
    $(buttonClass).removeClass('aqcstone-active aqcstone-pre-active');
    if (startIndex < 0 || endIndex < 0) return;
    if (startIndex > endIndex) {
        const swap = startIndex;
        startIndex = endIndex;
        endIndex = swap;
    }
    for (let i = startIndex; i <= endIndex; i++) {
        $(`${buttonClass}[data-value="${order[i]}"]`).addClass('aqcstone-active');
    }
    if (startIndex !== endIndex && startIndex > 0) {
        $(`${buttonClass}[data-value="${order[startIndex - 1]}"]`).addClass('aqcstone-pre-active');
    }
}

function vdbrcResetRangeFilterState() {
    Object.keys(vdbrcRangeFilterState).forEach(function (key) {
        vdbrcRangeFilterState[key].start = null;
        vdbrcRangeFilterState[key].end = null;
        vdbrcRangeFilterState[key].tab = null;
    });
}

function vdbrcSyncRangeFilterFromCookie(stateKey, buttonClass, cookieName, orderKey) {
    const state = vdbrcRangeFilterState[stateKey];
    const order = vdbrcRangeOrder(orderKey);
    const raw = getCookie(cookieName);
    state.tab = vdbrcCurrentStoneTab();
    state.start = null;
    state.end = null;
    $(buttonClass).removeClass('aqcstone-active aqcstone-pre-active');
    if (!raw || !order.length) return;

    const parts = raw.split(',').map(function (part) { return $.trim(part); }).filter(Boolean);
    if (!parts.length) return;

    let startIndex = order.indexOf(parts[0]);
    let endIndex = order.indexOf(parts[parts.length - 1]);
    if (startIndex === -1 || endIndex === -1) return;
    if (startIndex > endIndex) {
        const swap = startIndex;
        startIndex = endIndex;
        endIndex = swap;
    }

    state.start = order[startIndex];
    state.end = startIndex === endIndex ? null : order[endIndex];
    vdbrcPaintRangeButtons(buttonClass, order, startIndex, endIndex);
}

function vdbrcHandleRangeFilterClick(options) {
    const state = vdbrcRangeFilterState[options.stateKey];
    const stoneTab = vdbrcCurrentStoneTab();
    const order = vdbrcRangeOrder(options.orderKey);
    const clickedValue = options.clickedValue;

    if (!order.length || order.indexOf(clickedValue) === -1) return;

    if (state.tab !== stoneTab) {
        state.start = null;
        state.end = null;
        state.tab = stoneTab;
    }

    const hasSingle = state.start && !state.end;
    const hasRange = !!(state.start && state.end);

    if (hasSingle && clickedValue === state.start) {
        state.start = null;
        state.end = null;
        $(options.buttonClass).removeClass('aqcstone-active aqcstone-pre-active');
        document.cookie = `${options.cookieName}=`;
        applyFilterDebounced();
        return;
    }

    if (!state.start || hasRange) {
        state.start = clickedValue;
        state.end = null;
        vdbrcPaintRangeButtons(options.buttonClass, order, order.indexOf(clickedValue), order.indexOf(clickedValue));
        document.cookie = `${options.cookieName}=${clickedValue},${clickedValue}`;
        if (typeof options.afterSelect === 'function') options.afterSelect();
        applyFilterDebounced();
        return;
    }

    let startIndex = order.indexOf(state.start);
    let endIndex = order.indexOf(clickedValue);
    if (startIndex > endIndex) {
        const swap = startIndex;
        startIndex = endIndex;
        endIndex = swap;
    }
    state.start = order[startIndex];
    state.end = order[endIndex];
    vdbrcPaintRangeButtons(options.buttonClass, order, startIndex, endIndex);
    document.cookie = `${options.cookieName}=${state.start},${state.end}`;
    if (typeof options.afterSelect === 'function') options.afterSelect();
    applyFilterDebounced();
}

function vdbrcIsWhiteFancyValue(value) {
    return $.trim(String(value || '')).toLowerCase() === 'white';
}

function vdbrcFancyButtonsByValue(value) {
    const target = $.trim(String(value || ''));
    return $('.vdbrc_stone_fancy_color').filter(function () {
        return $.trim(String($(this).attr('data-value') || '')) === target;
    });
}

function vdbrcWhiteFancyButtons() {
    const $white = $('.vdbrc_stone_fancy_color').filter(function () {
        return vdbrcIsWhiteFancyValue($(this).attr('data-value'));
    });
    if ($white.length) return $white;

    let $fallback = $();
    $('.aqcstone-fancy-color-grid').each(function () {
        const $first = $(this).find('.vdbrc_stone_fancy_color').first();
        if ($first.length) $fallback = $fallback.add($first);
    });
    return $fallback;
}

function vdbrcFancyToggleMarkup(expanded) {
    if (expanded) {
        return `
            <div class="aqcstone-fancy-color-circle aqcstone-show-less-icon">
                <i class="ph ph-minus" style="font-size: 12px;"></i>
            </div>
            <div class="aqcstone-fancy-color-name vdbrc_fancy_label aqcstone-muted">Show Less</div>
        `;
    }
    return `
        <div class="aqcstone-fancy-color-circle aqcstone-show-more-icon">
            <i class="ph ph-plus" style="font-size: 12px;"></i>
        </div>
        <div class="aqcstone-fancy-color-name vdbrc_fancy_label aqcstone-muted">Show More</div>
    `;
}

function vdbrcSetFancyExpanded(expanded) {
    $('.aqcstone-fancy-color-grid').toggleClass('aqcstone-expanded', !!expanded);
    $('.vdbrc_fancy_show_more').html(vdbrcFancyToggleMarkup(!!expanded));
}

function vdbrcRevealSelectedFancyColor() {
    const tab = vdbrcCurrentStoneTab();
    const $sidebar = $(`#vdbrc_${tab}_filters`);
    const $scope = $sidebar.length ? $sidebar : $('.vdbrc_stone_filter_sidebar').not('.d-none');
    const hiddenSelected = $scope.find('.vdbrc_stone_fancy_color.aqcstone-active').filter('.aqcstone-hidden-fancy-item, .vdbrc_fancy_hidden');
    if (!hiddenSelected.length) return;
    vdbrcSetFancyExpanded(true);
}

function vdbrcClearColorGradeSelection() {
    vdbrcRangeFilterState.color.start = null;
    vdbrcRangeFilterState.color.end = null;
    vdbrcRangeFilterState.color.tab = vdbrcCurrentStoneTab();
    $('.vdbrc_stone_color').removeClass('aqcstone-active aqcstone-pre-active');
    document.cookie = 'vdbrc_color_white=';
}

function vdbrcSelectWhiteColorMode() {
    $('.vdbrc_stone_fancy_color').removeClass('aqcstone-active');
    vdbrcWhiteFancyButtons().addClass('aqcstone-active');
    document.cookie = 'vdbrc_fancy_color=';
    $('.vdbrc_stone_color').parent().removeClass('aqcstone_disable_filter');
}

function vdbrcSyncColorAndFancyFilters() {
    const params = new URLSearchParams(window.location.search);
    const urlFancy = $.trim(params.get('fancy_color') || '');
    const urlHasColor = !!(params.get('color_to') && params.get('color_from'));
    let fancy = $.trim(getCookie('vdbrc_fancy_color') || '');

    if (urlFancy && !vdbrcIsWhiteFancyValue(urlFancy)) {
        fancy = urlFancy;
    } else if (urlHasColor) {
        fancy = '';
    }

    $('.vdbrc_stone_color').parent().removeClass('aqcstone_disable_filter');

    if (fancy && !vdbrcIsWhiteFancyValue(fancy)) {
        document.cookie = `vdbrc_fancy_color=${fancy}`;
        vdbrcClearColorGradeSelection();
        $('.vdbrc_stone_fancy_color').removeClass('aqcstone-active');
        const $match = vdbrcFancyButtonsByValue(fancy);
        if ($match.length) {
            $match.addClass('aqcstone-active');
        } else {
            document.cookie = 'vdbrc_fancy_color=';
            vdbrcSelectWhiteColorMode();
            vdbrcSyncRangeFilterFromCookie('color', '.vdbrc_stone_color', 'vdbrc_color_white', 'colorArray');
        }
    } else {
        vdbrcSelectWhiteColorMode();
        vdbrcSyncRangeFilterFromCookie('color', '.vdbrc_stone_color', 'vdbrc_color_white', 'colorArray');
    }

    vdbrcRevealSelectedFancyColor();
}

$('body').on('click', '.vdbrc_stone_color', function () {
    $('.vdbrc_stone_color').parent().removeClass('aqcstone_disable_filter');
    vdbrcHandleRangeFilterClick({
        stateKey: 'color',
        buttonClass: '.vdbrc_stone_color',
        cookieName: 'vdbrc_color_white',
        orderKey: 'colorArray',
        clickedValue: String($(this).attr('data-value')),
        afterSelect: vdbrcSelectWhiteColorMode
    });
});

$('body').on('click', '.vdbrc_stone_fancy_color', function () {
    const fancyColorValue = $.trim(String($(this).attr('data-value') || ''));
    const alreadySelected = $(this).hasClass('aqcstone-active');

    if (!fancyColorValue) return;

    if (vdbrcIsWhiteFancyValue(fancyColorValue) || alreadySelected) {
        vdbrcSelectWhiteColorMode();
        applyFilterDebounced();
        return;
    }

    vdbrcClearColorGradeSelection();
    $('.vdbrc_stone_fancy_color').removeClass('aqcstone-active');
    vdbrcFancyButtonsByValue(fancyColorValue).addClass('aqcstone-active');
    $('.vdbrc_stone_color').parent().removeClass('aqcstone_disable_filter');
    document.cookie = `vdbrc_fancy_color=${fancyColorValue}`;
    vdbrcRevealSelectedFancyColor();
    applyFilterDebounced();
});

$('body').on('click', '.vdbrc_stone_clarity', function () {
    vdbrcHandleRangeFilterClick({
        stateKey: 'clarity',
        buttonClass: '.vdbrc_stone_clarity',
        cookieName: 'vdbrc_clarity',
        orderKey: 'clarityArray',
        clickedValue: String($(this).attr('data-value'))
    });
});

$('body').on('click', '.vdbrc_stone_cut', function () {
    vdbrcHandleRangeFilterClick({
        stateKey: 'cut',
        buttonClass: '.vdbrc_stone_cut',
        cookieName: 'vdbrc_cut',
        orderKey: 'cutArray',
        clickedValue: String($(this).attr('data-value'))
    });
});
$('body').on('click', '.vdbrc_stone_polish', function () {
    vdbrcHandleRangeFilterClick({
        stateKey: 'polish',
        buttonClass: '.vdbrc_stone_polish',
        cookieName: 'vdbrc_polish',
        orderKey: 'polishArray',
        clickedValue: String($(this).attr('data-value'))
    });
});
$('body').on('click', '.vdbrc_stone_symmetry', function () {
    vdbrcHandleRangeFilterClick({
        stateKey: 'symmetry',
        buttonClass: '.vdbrc_stone_symmetry',
        cookieName: 'vdbrc_symmetry',
        orderKey: 'symmetryArray',
        clickedValue: String($(this).attr('data-value'))
    });
});
$('body').on('click', '.vdbrc_stone_lab', function () {
    const value = String($(this).attr('data-value') || '');
    if (!value) return;

    const selected = (getCookie('vdbrc_lab') || '')
        .split(',')
        .map(function (part) { return $.trim(part); })
        .filter(Boolean);
    const existingIndex = selected.indexOf(value);

    if (existingIndex === -1) {
        selected.push(value);
    } else {
        selected.splice(existingIndex, 1);
    }

    document.cookie = `vdbrc_lab=${selected.join(',')}`;
    $('.vdbrc_stone_lab').removeClass('aqcstone-active');
    selected.forEach(function (lab) {
        $(`.vdbrc_stone_lab[data-value="${lab}"]`).addClass('aqcstone-active');
    });
    applyFilterDebounced();
});
$('body').on('change', '#vdbrc_sorting_option', function () {
    const sortByValue = $(this).find('option:selected').val();

    document.cookie = `vdbrc_sorting=${sortByValue}`;
    applyFilterDebounced();
});
$('body').on('click', '.vdbrc_advanced_toggle', function () {
    $('.vdbrc_advanced_filters').toggleClass('aqcstone-expanded');

    if ($('.vdbrc_advanced_filters').hasClass('aqcstone-expanded')) {
        $('.vdbrc_advanced_chevron').css('transform', 'rotate(0deg)');

        const section = $(this).closest('.vdbrc_filter_section')[0];
        if (section) {
            // Wait for the expand transition so scroll heights are settled.
            setTimeout(function () {
                let scroller = null;
                for (let el = section.parentElement; el; el = el.parentElement) {
                    const overflowY = window.getComputedStyle(el).overflowY;
                    if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
                        scroller = el;
                        break;
                    }
                }

                if (scroller) {
                    const offset = section.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
                    scroller.scrollTo({ top: scroller.scrollTop + offset - 10, behavior: 'smooth' });
                } else {
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 350);
        }
    } else {
        $('.vdbrc_advanced_chevron').css('transform', 'rotate(180deg)');
    }
});
$('body').on('click', '.vdbrc_filter_header', function () {
    const $section = $(this).closest('.aqcstone-filter-section');
    $section.toggleClass('aqcstone-collapsed');

    const $icon = $(this).find('.aqcstone-filter-collapse-icon img');

    if ($section.hasClass('aqcstone-collapsed')) {
        $icon.css('transform', 'rotate(180deg)');
    } else {
        $icon.css('transform', 'rotate(0deg)');
    }
});
$('body').on('click', '.vdbrc_filter_input_arrow_up, .vdbrc_filter_input_arrow_down', function (e) {
    e.preventDefault();

    const targetId = $(this).data('target');
    const action = $(this).data('action');
    const step = parseFloat($(this).data('step')) || 1;

    const $input = $('#' + targetId);
    if (!$input.length) return;

    const min = parseFloat($input.attr('min')) || 0;
    const max = parseFloat($input.attr('max')) || Infinity;

    let val = parseFloat(($input.val() || '').toString().replace(/,/g, '')) || 0;

    if (action === 'inc') val += step;
    if (action === 'dec') val -= step;

    // Clamp between min & max
    val = Math.min(max, Math.max(min, val));

    // Fix floating point errors (0.30000000004 etc.)
    val = Math.round(val * 100) / 100;

    // Keep 2 decimal format
    $input.val(val.toFixed(2));

    // Trigger both input and change events
    document.getElementById(targetId)?.dispatchEvent(new Event("blur", { bubbles: true }));
});

$('body').on('click', '.vdbrc_fancy_show_more', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const isExpanded = $('.aqcstone-fancy-color-grid').first().hasClass('aqcstone-expanded');
    vdbrcSetFancyExpanded(!isExpanded);
});

$('body').on('click', '.vdbrc_sorting_th', function () {

    const allHeaders = $('.vdbrc_sorting_th');
    const clickedHeader = $(this);

    const clickedField = clickedHeader.data('sort-by');

    const sortingFieldInput = $('#sorting_field');
    const sortingSeqInput = $('#sorting_seq');

    const currentField = sortingFieldInput.val();
    let currentSeq = sortingSeqInput.val();

    // Reset all headers to default icon
    allHeaders.removeClass('ph-caret-up ph-caret-down').addClass('ph-caret-up-down');
    allHeaders.find('i').removeClass('ph-caret-up ph-caret-down').addClass('ph-caret-up-down');

    // Determine next sorting sequence
    if (currentField === clickedField) {
        currentSeq = (currentSeq === 'ASC') ? 'DESC' : 'ASC';
    } else {
        currentSeq = 'ASC';
    }

    // Update hidden inputs
    sortingFieldInput.val(clickedField);
    sortingSeqInput.val(currentSeq);

    // Update clicked header icon
    clickedHeader.removeClass('ph-caret-up-down').addClass(currentSeq === 'ASC' ? 'ph-caret-up' : 'ph-caret-down');
    clickedHeader.find('i').removeClass('ph-caret-up-down').addClass(currentSeq === 'ASC' ? 'ph-caret-up' : 'ph-caret-down');

    applyFilterDebounced();
});
$('body').on('click', '.vdbrc_stone_list_row', function () {
    const detailDiv = $(this).parent().find('.vdbrc_stone_list_detail');

    // If this detail is already open, close it
    if (detailDiv.hasClass('aqcstone-expanded')) {
        detailDiv.removeClass('aqcstone-expanded');
    }
    else {
        // Close all other open details
        $('.vdbrc_stone_list_detail').removeClass('aqcstone-expanded');

        // Open the clicked one
        detailDiv.addClass('aqcstone-expanded');
    }

    const container = $('.vdbrc_thumbnail_container');
    const img = container.find('img');
    const video = container.find('video');
    const iframe = container.find('iframe');

    img.show();

    // Stop & clear all videos
    if (video.length) {
        video.each(function () {
            this.pause();
            this.removeAttribute('src');
            this.load(); // release resource properly
        });
    }
    // Clear iframe sources
    if (iframe.length) {
        iframe.attr('src', '');
    }

    // Reset visibility
    video.hide();
    iframe.hide();
});
$('body').on('click', '.vdbrc_stone_list_report', function () {
    const certUrl = $(this).attr('data-report-url');

    if (!certUrl || $.trim(certUrl) === '') {
        return;
    }

    window.open(certUrl, '_blank');
});

$('body').on('click', '.aqcstone-arrow-prev', function () {
    const shapeGrid = $(this).closest('.aqcstone-shape-wrapper').find('.aqcstone-shape-grid');

    if (shapeGrid.length) {
        shapeGrid[0].scrollBy({ left: -200, behavior: 'smooth' });
    }
});
$('body').on('click', '.aqcstone-arrow-next', function () {
    const shapeGrid = $(this).closest('.aqcstone-shape-wrapper').find('.aqcstone-shape-grid');

    if (shapeGrid.length) {
        shapeGrid[0].scrollBy({ left: 200, behavior: 'smooth' });
    }
});

$('body').on('click', '.vdbrc_stone_video_btn', function (event) {
    event.preventDefault();

    const button = $(this);
    const videoUrl = button.attr('data-video-url');

    const imageBox = button.closest('.aqcstone-detail-image-box');
    const container = imageBox.find('.vdbrc_thumbnail_container').first();

    const mainImage = container.find('.aqcstone-detail-main-img').first();
    const iframe = container.find('.vdb_stone_video').first();

    const playIcon = button.find('.play-icon');
    const imageIcon = button.find('.image-icon');

    const isVideoActive = button.hasClass('video-active');

    if (isVideoActive) {
        // Show product image
        iframe.attr('src', '').hide();
        mainImage.show();

        playIcon.show();
        imageIcon.hide();

        button.removeClass('video-active');
    } else {
        // Show 360 iframe
        mainImage.hide();
        iframe.attr('src', videoUrl).show();

        playIcon.hide();
        imageIcon.show();

        button.addClass('video-active');
    }
});
//#endregion

//#region : Reset All Filters
$('body').on('click', '.vdbrc_reset_filters', async function () {
    await resetFilter();
    applyFilterDebounced();
});

async function resetFilter() {
    // Clear all filter-related cookies
    const filterCookies = [
        'vdbrc_shape', 'vdbrc_color_white', 'vdbrc_clarity', 'vdbrc_cut', 'vdbrc_polish', 'vdbrc_symmetry',
        'vdbrc_lab', 'vdbrc_min_carat', 'vdbrc_max_carat', 'vdbrc_min_price', 'vdbrc_max_price',
        'vdbrc_min_depth', 'vdbrc_max_depth', 'vdbrc_min_table', 'vdbrc_max_table',
        'vdbrc_min_ratio', 'vdbrc_max_ratio', 'vdbrc_fancy_color', 'vdbrc_sorting'
    ];
    filterCookies.forEach(cookieName => {
        if (isRingSelected && cookieName === 'vdbrc_shape') {
            return;
        }
        document.cookie = `${cookieName}=`;
    });

    sliderObjArray.forEach(obj => {
        if (typeof obj.resetSlider === 'function') {
            obj.resetSlider();
        }
    });

    // Clear all visual active states from filters
    vdbrcResetRangeFilterState();
    $('.vdbrc_stone_shape').removeClass('aqcstone-active');
    $('.vdbrc_stone_color').removeClass('aqcstone-active aqcstone-pre-active');
    $('.vdbrc_stone_fancy_color').removeClass('aqcstone-active');
    vdbrcSelectWhiteColorMode();
    vdbrcSetFancyExpanded(false);
    $('.vdbrc_stone_clarity').removeClass('aqcstone-active aqcstone-pre-active');
    $('.vdbrc_stone_cut').removeClass('aqcstone-active aqcstone-pre-active');
    $('.vdbrc_stone_polish').removeClass('aqcstone-active aqcstone-pre-active');
    $('.vdbrc_stone_symmetry').removeClass('aqcstone-active aqcstone-pre-active');
    $('.vdbrc_stone_lab').removeClass('aqcstone-active');

    $('#vdbrc_sorting_option').val('Lowest Price');
    $("#sorting_field").val('');
    $("#sorting_seq").val('ASC');

    // Clear URL parameters (keep diamond_type)
    const currentStoneType = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
    const urlParams = new URLSearchParams(window.location.search);

    let cleanUrl = window.location.pathname;
    const params = new URLSearchParams();

    params.set('ref_collection', urlParams.get('ref_collection'));

    if (currentStoneType) {
        params.set('diamond_type', currentStoneType);
    }

    if (isRingSelected && urlParams.has('ring-handle')) {
        params.set('ring-handle', urlParams.get('ring-handle'));
    }

    const queryString = params.toString();

    if (queryString) {
        cleanUrl += `?${queryString}`;
    }

    window.top.history.pushState({}, '', cleanUrl);
}
//#endregion

function deepLinkStone() {
    let params = new URLSearchParams(window.location.search);

    if (!params.has('diamond_type')) return;

    let diamondType = params.get('diamond_type') || STONE_TYPES[0];
    document.cookie = `vdbrc_stone_tab=${diamondType}`;

    let reqViewType = params.get('view_type') || 'stone_list';
    if (reqViewType) {
        document.cookie = `vdbrc_view_type=${reqViewType}`;
    }

    let reqStoneView = params.get('stone_view') || 'grid_view';
    if (reqStoneView) {
        document.cookie = `vdbrc_stone_tab_view=${reqStoneView}`;
    }

    let reqSortBy = params.get('sorting') || '';
    if (reqSortBy) {
        document.cookie = `vdbrc_sorting=${reqSortBy}`;
    }

    let reqShape = params.get('shape') || '';
    if (reqShape) {
        document.cookie = `vdbrc_shape=${reqShape}`;
    }

    let colorTo = params.get('color_to') || '';
    let colorFrom = params.get('color_from') || '';
    if (colorTo && colorFrom) {
        document.cookie = `vdbrc_color_white=${colorTo},${colorFrom}`;
    }

    let reqFancyColor = params.get('fancy_color') || '';
    if (reqFancyColor) {
        document.cookie = `vdbrc_fancy_color=${reqFancyColor}`;
    }

    let clarityTo = params.get('clarity_to') || '';
    let clarityFrom = params.get('clarity_from') || '';
    if (clarityTo && clarityFrom) {
        document.cookie = `vdbrc_clarity=${clarityTo},${clarityFrom}`;
    }

    let cutTo = params.get('cut_to') || '';
    let cutFrom = params.get('cut_from') || '';
    if (cutTo && cutFrom) {
        document.cookie = `vdbrc_cut=${cutTo},${cutFrom}`;
    }

    let polishTo = params.get('polish_to') || '';
    let polishFrom = params.get('polish_from') || '';
    if (polishTo && polishFrom) {
        document.cookie = `vdbrc_polish=${polishTo},${polishFrom}`;
    }

    let symmetryTo = params.get('symmetry_to') || '';
    let symmetryFrom = params.get('symmetry_from') || '';
    if (symmetryTo && symmetryFrom) {
        document.cookie = `vdbrc_symmetry=${symmetryTo},${symmetryFrom}`;
    }

    let reqLab = params.get('lab') || '';
    if (reqLab) {
        document.cookie = `vdbrc_lab=${reqLab}`;
    }

    let reqMinCarat = params.get('carat_min') || '';
    let reqMaxCarat = params.get('carat_max') || '';
    if (reqMinCarat) {
        document.cookie = `vdbrc_min_carat=${reqMinCarat}`;
    }
    if (reqMaxCarat) {
        document.cookie = `vdbrc_max_carat=${reqMaxCarat}`;
    }

    let reqMinPrice = params.get('min_price') || '';
    let reqMaxPrice = params.get('max_price') || '';
    if (reqMinPrice) {
        document.cookie = `vdbrc_min_price=${reqMinPrice}`;
    }
    if (reqMaxPrice) {
        document.cookie = `vdbrc_max_price=${reqMaxPrice}`;
    }

    let reqMinDepth = params.get('depth_min') || '';
    let reqMaxDepth = params.get('depth_max') || '';
    if (reqMinDepth) {
        document.cookie = `vdbrc_min_depth=${reqMinDepth}`;
    }
    if (reqMaxDepth) {
        document.cookie = `vdbrc_max_depth=${reqMaxDepth}`;
    }

    let reqMinTable = params.get('table_min') || '';
    let reqMaxTable = params.get('table_max') || '';
    if (reqMinTable) {
        document.cookie = `vdbrc_min_table=${reqMinTable}`;
    }
    if (reqMaxTable) {
        document.cookie = `vdbrc_max_table=${reqMaxTable}`;
    }

    let reqMinRatio = params.get('meas_ratio_from') || '';
    let reqMaxRatio = params.get('meas_ratio_to') || '';
    if (reqMinRatio) {
        document.cookie = `vdbrc_min_ratio=${reqMinRatio}`;
    }
    if (reqMaxRatio) {
        document.cookie = `vdbrc_max_ratio=${reqMaxRatio}`;
    }
}

function syncFiltersFromCookies() {
    // Stone Tab
    const stoneTab = getCookie('vdbrc_stone_tab');
    if (stoneTab) {
        $('.vdbrc_stone_tab').removeClass('aqcstone-active').addClass('aqcstone-inactive');
        $(`.vdbrc_stone_tab[data-stone-type="${stoneTab}"]`).addClass('aqcstone-active').removeClass('aqcstone-inactive');
    }

    // View Type 
    const viewType = getCookie('vdbrc_view_type');
    if (viewType) {
        $('.vdbrc_view_tab').removeClass('aqcstone-active').addClass('aqcstone-inactive');
        $(`.vdbrc_view_tab[data-view="${viewType}"]`).addClass('aqcstone-active').removeClass('aqcstone-inactive').click();
    }

    // Stone View 
    const stoneView = getCookie('vdbrc_stone_tab_view');
    if (stoneView) {
        $('.vdbrc_stone_view_type').removeClass('aqcstone-active').addClass('aqcstone-inactive');
        $(`.vdbrc_stone_view_type[data-layout="${stoneView}"]`).addClass('aqcstone-active').removeClass('aqcstone-inactive').click();
    }

    // Sorting
    var vdbrc_sorting = getCookie("vdbrc_sorting");
    if (vdbrc_sorting) {
        $('#vdbrc_sorting_option').val(vdbrc_sorting);
    }

    // Simple active-class cookie sync helper
    function setLastActiveFromCookie(cookieKey, selector) {
        const val = getCookie(cookieKey);
        if (!val) return;
        const last = val.split(',').pop();
        if (last) $(`${selector}[data-value="${last}"]`).addClass('aqcstone-active');
    }

    setLastActiveFromCookie('vdbrc_shape', '.vdbrc_stone_shape');
    vdbrcSyncColorAndFancyFilters();
    vdbrcSyncRangeFilterFromCookie('clarity', '.vdbrc_stone_clarity', 'vdbrc_clarity', 'clarityArray');
    vdbrcSyncRangeFilterFromCookie('cut', '.vdbrc_stone_cut', 'vdbrc_cut', 'cutArray');
    vdbrcSyncRangeFilterFromCookie('polish', '.vdbrc_stone_polish', 'vdbrc_polish', 'polishArray');
    vdbrcSyncRangeFilterFromCookie('symmetry', '.vdbrc_stone_symmetry', 'vdbrc_symmetry', 'symmetryArray');

    $('.vdbrc_stone_lab').removeClass('aqcstone-active');
    (getCookie('vdbrc_lab') || '').split(',').map(function (part) {
        return $.trim(part);
    }).filter(Boolean).forEach(function (lab) {
        $(`.vdbrc_stone_lab[data-value="${lab}"]`).addClass('aqcstone-active');
    });

    STONE_TYPES.forEach(type => {
        syncSlider(type, "price", 2, true);
        syncSlider(type, "carat", 2);
        syncSlider(type, "ratio", 1);
        syncSlider(type, "depth", 1);
        syncSlider(type, "table", 1);
    });
}

function syncSlider(type, key, decimals, isPrice = false) {
    const minCookie = getCookie(`vdbrc_min_${key}`);
    const maxCookie = getCookie(`vdbrc_max_${key}`);
    if (!minCookie || !maxCookie) return;

    let minVal = parseFloat(minCookie);
    let maxVal = parseFloat(maxCookie);
    if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];

    const minDisplay = isPrice ? vdbrcFormatMoney(minVal * 100, moneyFormat, true) : minVal.toFixed(decimals);
    const maxDisplay = isPrice ? vdbrcFormatMoney(maxVal * 100, moneyFormat, true) : maxVal.toFixed(decimals);

    // textboxes
    $(`.vdbrc_min_${key}_${type}_web`).val(minDisplay);
    $(`.vdbrc_max_${key}_${type}_web`).val(maxDisplay);

    // slider inputs + sliders use raw number
    $(`#vdbrc_${key}_from_slider_input_${type}_web`).val(minVal);
    $(`#vdbrc_${key}_to_slider_input_${type}_web`).val(maxVal);
    $(`#vdbrc_${key}_from_slider_${type}_web`).val(minVal);
    $(`#vdbrc_${key}_to_slider_${type}_web`).val(maxVal);

    // refresh slider UI
    document.getElementById(`vdbrc_${key}_from_slider_${type}_web`)?.dispatchEvent(new Event("input", { bubbles: true }));
    document.getElementById(`vdbrc_${key}_to_slider_${type}_web`)?.dispatchEvent(new Event("input", { bubbles: true }));
    document.getElementById(`vdbrc_${key}_from_slider_${type}_web`)?.dispatchEvent(new Event("blur", { bubbles: true }));
    document.getElementById(`vdbrc_${key}_to_slider_${type}_web`)?.dispatchEvent(new Event("blur", { bubbles: true }));
}

//#region : Handle Stone Grid & List View HTML Generation
function formatValue(value, defaultValue = "") {
    return value ?? defaultValue;
}
function formatSize(size) {
    return size ? Number(size).toFixed(2) : "";
}
function getStoneGridHtml(stone, isCompared) {
    const stock_num = stone["stock_num"];
    const stock_id = stone["id"];
    const vendor_id = formatValue(stone["vendor_id"]);
    const shape = formatValue(stone["shape"]);
    const size = formatSize(stone["size"]);
    const clarity = formatValue(stone["clarity"]);
    const cut = formatValue(stone["cut"],'-');
    const color = formatValue(stone["color"]);
    const image_url = vdbrcResolveStoneImageUrl(formatValue(stone["image_url"]));
    const video_url = formatValue(stone["video_url"]);
    const long_title = formatValue(stone["long_title"]);
    const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
    const total_sales_price = stone["total_sales_price"];

    var price = handlePriceData(stone_currency_code, total_sales_price);

    const name = long_title || `${shape} ${size} ${color} ${clarity}`;
    const displayName = `${size} carat ${shape} <span>${color} ${clarity} Lab</span>`;

    const activeClass = isCompared ? 'aqcstone-active' : '';
    // const heartIcon = isCompared ? '' : '';

    const currentParams = new URLSearchParams(window.location.search);
    const refCollection = currentParams.get('ref_collection');
    const shapeVal = currentParams.get('shape');
    const flowVal = currentParams.get('flow');

    const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
    const stockParamKey = vdbrcStoneTab === "natural" ? "natural_stock_num" : "labgrown_stock_num";
    const detailParams = new URLSearchParams({
        [stockParamKey]: stock_num,
        vendor_id: vendor_id,
        ...(isRingSelected === true ? { 'ring-handle': ringHandle } : {}),
        ...(refCollection ? { ref_collection: refCollection } : {}),
        ...(shapeVal ? { shape: shapeVal } : {}),
        ...(flowVal ? { flow: flowVal } : {})
    });

    const detailUrl = `/products/stone?${detailParams.toString()}`;
    const completeUrl = vdbrcStoneCompleteUrl(detailParams, detailUrl);
    const hasStoneImage = Boolean(image_url) && image_url !== no_image_url;
    const thumbSrc = hasStoneImage ? VDBRC_STONE_THUMB_BLANK : no_image_url;
    const mediaLoaderUrl = typeof stone_media_loader_url !== 'undefined' ? stone_media_loader_url : '';

    return `
        <div class="aqcstone-product-card vdbrc_grid_row_tr" data-url="${detailUrl}" data-stock-num="${stock_num}" data-stock-id="${stock_id}" data-video-url="${video_url}" data-image-url="${image_url}">
            <div class="aqcstone-product-image-wrapper${hasStoneImage ? ' is-media-loading' : ''}">
                ${hasStoneImage ? `<div class="aqc-media-loader" aria-hidden="false"><img class="aqc-media-loader__spinner" src="${mediaLoaderUrl}" alt="" width="36" height="36"></div>` : ''}
                <img src="${thumbSrc}" alt="${name}" class="aqcstone-product-image vdbrc_stone_grid_thumbnail" data-src="${image_url}" width="400" height="400" loading="lazy" decoding="async">
                <div class="aqcstone-product-badge text-center d-none">
                    <span class="aqcstone-badge-text">Best Seller</span>
                </div>
                <button class="aqcstone-wishlist-btn vdbrc_stone_compare_btn ${activeClass}">
                    <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/352c2594416ccbda6917b9987721446b237db0e0.svg?v=1774375047" alt="Wishlist" />
                    <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/compare-active.png?v=1767724339" alt="Wishlist" />
                </button>
                <button class="aqcstone-quick-view-btn vdbrc_stone_quick_view" data-stock-id="${stock_id}">
                    <i class="ph ph-magnifying-glass"></i>
                </button>
            </div>
            <div class="aqcstone-product-info">
                <div class="aqcstone-product-header">
                    <h3 class="aqcstone-product-name">${displayName}</h3>
                    <span class="aqcstone-product-price">${price}</span>
                </div>
                <div class="aqcstone-card-actions">
                    <button class="aqcstone-action-btn aqcstone-more-info vdbrc_view_stone_detail" data-url="${detailUrl}">More Info</button>
                    <button class="aqcstone-action-btn aqcstone-complete-ring vdbrc_complete_my_ring_btn${isRingSelected ? '' : ' d-none'}" data-stock-num="${stock_num}" data-stock-key="${stockParamKey}" data-vendor-id="${vendor_id}" data-url="${completeUrl}">
                        <i class="ph ph-diamond"></i> ${isRingSelected ? 'Select Stone' : 'Complete My Ring'} <i class="ph ph-arrow-right"></i>
                    </button>
                </div>
                <div class="aqcstone-product-specs">
                    <div class="aqcstone-spec-item">
                        <div class="aqcstone-spec-value">${size}</div>
                        <div class="aqcstone-spec-label">Carat</div>
                    </div>
                    <div class="aqcstone-spec-item">
                        <div class="aqcstone-spec-value">${color}</div>
                        <div class="aqcstone-spec-label">Color</div>
                    </div>
                    <div class="aqcstone-spec-item">
                        <div class="aqcstone-spec-value">${clarity}</div>
                        <div class="aqcstone-spec-label">Clarity</div>
                    </div>
                    <div class="aqcstone-spec-item">
                        <div class="aqcstone-spec-value">${cut}</div>
                        <div class="aqcstone-spec-label">Cut</div>
                    </div>
                </div>
            </div>
        </div>
    `;
}
function getStoneListHtml(stone, isCompared) {
    if (showMatchStonePair && stone.length > 0) {
        const hasPair = showMatchStonePair && stone.length >= 2;

        const buildStoneData = (s) => {
            const stock_num = s["stock_num"];
            const stock_id = s["id"];
            const vendor_id = formatValue(s["vendor_id"]);
            const lab = formatValue(s["lab"]);
            const shape = formatValue(s["shape"]);
            const size = formatSize(s["size"]);
            const clarity = formatValue(s["clarity"]);
            const cut = formatValue(s["cut"]);
            const image_url = vdbrcResolveStoneImageUrl(formatValue(s["image_url"]));
            const color = formatValue(s["color"]);
            const polish = formatValue(s["polish"]);
            const symmetry = formatValue(s["symmetry"]);
            const depth_per = formatValue(s["depth_percent"]);
            const table_per = formatValue(s["table_percent"]);
            const video_url = formatValue(s["video_url"]);
            const cert_url = formatValue(s["cert_url"]);
            const video_type = formatValue(s["video_type"]);
            const stone_currency_code = s["currency_code"] ? s["currency_code"] : "USD";
            const meas_ratio = formatValue(s["meas_ratio"]);
            const girdle_condition = formatValue(s["girdle_condition"]);
            const girdle_percent = formatValue(s["girdle_percent"]);
            const total_sales_price = s["total_sales_price"];
            const long_title = formatValue(s["long_title"]);

            const measurements_arr = [
                formatValue(s["meas_length"], "0.00"),
                formatValue(s["meas_width"], "0.00"),
                formatValue(s["meas_depth"], "0.00"),
            ];
            const measurements = measurements_arr.every((el) => el === "0.00")
                ? "-"
                : measurements_arr.join(" x ");

            const price = handlePriceData(stone_currency_code, total_sales_price);

            let shape_icon_url = "";
            const shapeElement = $(`.vdbrc_stone_shape[data-value="${shape}"]`);
            if (shapeElement.length) {
                shape_icon_url = shapeElement.attr("data-icon-url");
            }

            const videoHtml =
                video_type === "native"
                    ? `<video class="vdb_stone_video" src="" controls controlsList="nodownload" data-src="${video_url}" style="display:none"></video>`
                    : `<iframe class="vdb_stone_video" allow="autoplay" src="" frameborder="0" data-src="${video_url}" style="display:none"></iframe>`;

            return {
                stock_num,
                stock_id,
                vendor_id,
                lab,
                shape,
                size,
                clarity,
                cut,
                image_url,
                color,
                polish,
                symmetry,
                depth_per,
                table_per,
                video_url,
                cert_url,
                video_type,
                stone_currency_code,
                meas_ratio,
                girdle_condition,
                girdle_percent,
                total_sales_price,
                long_title,
                measurements,
                price,
                shape_icon_url,
                videoHtml,
            };
        };

        const s1 = buildStoneData(stone[0]);
        const s2 = hasPair ? buildStoneData(stone[1]) : null;

        const activeClass = isCompared ? "aqcstone-active" : "";
        const vdbrcStoneTab = getCookie("vdbrc_stone_tab") || STONE_TYPES[0];
        const stockParamKey = vdbrcStoneTab === "natural" ? "natural_stock_num" : "labgrown_stock_num";

        // Use first stone for details URL (common pattern). Adjust if you need both.
        const params = new URLSearchParams({
            [stockParamKey]: s1.stock_num,
            vendor_id: s1.vendor_id,
            ...(isRingSelected === true ? { "ring-handle": ringHandle } : {}),
            "show_match_stone_pair": "true"
        });

        const name =
            s1.long_title || `${s1.shape} ${s1.size} ${s1.color} ${s1.clarity}`;
        const displayName = `${s1.size} carat ${s1.shape} <span>${s1.color} ${s1.clarity} Lab</span>`;

        // Helpers for dual display (only show second line if pair exists)
        const dualLine = (v) => (hasPair ? `<p class="dual-item">${v}</p>` : "");

        return `
            <div class="aqcstone-list-item vdbrc_list_row_tr" data-stock-num="${s1.stock_num}" data-stock-id="${s1.stock_id}" data-video-url="${s1.video_url}" data-image-url="${s1.image_url}">
                <div class="aqcstone-list-row vdbrc_stone_list_row">
                    <div class="aqcstone-list-cell" data-label="Shape">
                        <img src="${s1.shape_icon_url}" style="width:30px;height:30px;margin-right:8px;">
                        ${hasPair ? `<img src="${s2.shape_icon_url}" style="width:30px;height:30px;margin-right:8px;">` : ""}
                        ${s1.shape}
                    </div>
                    <div class="aqcstone-list-cell aqcstone-list-price" data-label="Price">
                        ${s1.price}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Carat">
                        ${s1.size}
                        ${hasPair ? `<p class="dual-carat dual-item">${s2.size}</p>` : ""}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Cut">
                        ${s1.cut}
                        ${hasPair ? `<p class="dual-cut dual-item">${s2.cut}</p>` : ""}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Color">
                        ${s1.color}
                        ${hasPair ? `<p class="dual-color dual-item">${s2.color}</p>` : ""}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Ratio">
                        ${s1.meas_ratio}
                        ${hasPair ? `<p class="dual-ratio dual-item">${s2.meas_ratio}</p>` : ""}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Clarity">
                        ${s1.clarity}
                        ${hasPair ? `<p class="dual-clarity dual-item">${s2.clarity}</p>` : ""}
                    </div>
                    <div class="aqcstone-list-cell" data-label="Measurement">
                        ${s1.measurements}
                        ${hasPair ? `<p class="dual-measurement dual-item">${s2.measurements}</p>` : ""}
                    </div>
                    <!--<div class="aqcstone-list-cell" data-label="Girdle">
                        ${s1.girdle_condition || "-"}
                        ${hasPair ? `<p class="dual-girdle dual-item">${s2.girdle_condition || "-"}</p>` : ""}
                    </div>-->
                    <div class="aqcstone-list-cell vdbrc_stone_list_report" data-label="Report" data-report-url="${window.vdbrcIsUncertifiedLab && window.vdbrcIsUncertifiedLab(s1.lab) ? '' : s1.cert_url}">
                        ${s1.lab}${window.vdbrcIsUncertifiedLab && window.vdbrcIsUncertifiedLab(s1.lab) ? '' : ' <i class="ph ph-arrow-square-out" style="font-size:12px;color:#666;"></i>'}
                    </div>
                    <div class="aqcstone-list-cell aqcstone-list-compare vdbrc_stone_compare_btn ${activeClass}" data-label="Compare">
                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/352c2594416ccbda6917b9987721446b237db0e0.svg?v=1774375047" alt="Wishlist" style="width:20px;" />
                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/compare-active.png?v=1767724339" alt="Wishlist" />
                    </div>
                </div>
                <div class="aqcstone-list-detail vdbrc_stone_list_detail">
                    <div class="aqcstone-detail-container">
                        <!-- Left Image -->
                        <div class="aqcstone-detail-left">
                            <div class="aqcstone-detail-image-box">
                                <div class="vdbrc_thumbnail_container">
                                    <img src="${s1.image_url}" data-src="${s1.image_url}" onerror="this.onerror=null;this.src='${no_image_url}';" alt="Diamond" class="aqcstone-detail-main-img">
                                    ${s1.videoHtml}
                                </div>
                                <button class="aqcstone-play-btn vdbrc_stone_video_btn" data-video-url="${s1.video_url}">
                                    <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/play-icon-list.png?v=1768510102" alt="Play">
                                </button>
                                <button class="aqcstone-zoom-btn vdbrc_stone_quick_view" data-stock-id="${s1.stock_id}">
                                    <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/search-icon-list.png?v=1768510103" alt="Zoom">
                                </button>
                            </div>
                            ${hasPair ? `
                                <div class="aqcstone-detail-image-box dual-item-image-box">
                                    <div class="vdbrc_thumbnail_container">
                                        <img src="${s2.image_url}" data-src="${s2.image_url}" onerror="this.onerror=null;this.src='${no_image_url}';" alt="Diamond" class="aqcstone-detail-main-img">
                                        ${s2.videoHtml}
                                    </div>
                                    <button class="aqcstone-play-btn vdbrc_stone_video_btn" data-video-url="${s2.video_url}">
                                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/play-icon-list.png?v=1768510102" alt="Play">
                                    </button>
                                    <button class="aqcstone-zoom-btn vdbrc_stone_quick_view" data-stock-id="${s2.stock_id}">
                                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/search-icon-list.png?v=1768510103" alt="Zoom">
                                    </button>
                                </div>
                            ` : ""
            }
                        </div>
                        <!-- Center Content -->
                        <div class="aqcstone-detail-center">
                            <h3 class="aqcstone-detail-heading">${displayName}</h3>
                            <div class="aqcstone-detail-price-large">${s1.price}</div>
                            <div class="aqcstone-detail-grid-box">
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${s1.size}</span>
                                    <span class="aqcstone-box-label">CARAT</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${s1.color}</span>
                                    <span class="aqcstone-box-label">COLOR</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${s1.clarity}</span>
                                    <span class="aqcstone-box-label">CLARITY</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${s1.cut}</span>
                                    <span class="aqcstone-box-label">CUT</span>
                                </div>
                            </div>
                            <div class="aqcstone-detail-action-col">
                                <button class="aqcstone-btn-outline vdbrc_view_stone_detail" data-url="/products/stone?${params.toString()}">
                                VIEW DETAILS <i class="ph ph-arrow-right"></i>
                                </button>
                                <button class="aqcstone-btn-primary vdbrc_complete_my_ring_btn${isRingSelected ? '' : ' d-none'}" data-stock-num="${s1.stock_num}" data-stock-key="${stockParamKey}" data-vendor-id="${s1.vendor_id}" data-url="${vdbrcStoneCompleteUrl(params, '/products/stone?' + params.toString())}">
                                <i class="ph ph-diamond"></i> ${isRingSelected ? 'SELECT STONE' : 'COMPLETE MY RING'} <i class="ph ph-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                        <!-- Right Specs -->
                        <div class="aqcstone-detail-right">
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Cut</span>
                                    <span class="aqcstone-rs-value">${s1.cut}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Girdle Thickness</span>
                                    <span class="aqcstone-rs-value">${s1.girdle_condition}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Symmetry</span>
                                    <span class="aqcstone-rs-value">${s1.symmetry}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Table</span>
                                    <span class="aqcstone-rs-value">${s1.table_per ? s1.table_per + "%" : "N/A"}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Polish</span>
                                    <span class="aqcstone-rs-value">${s1.polish}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Depth</span>
                                    <span class="aqcstone-rs-value">${s1.depth_per ? s1.depth_per + "%" : "N/A"}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Girdle Percentage</span>
                                    <span class="aqcstone-rs-value">${s1.girdle_percent ? s1.girdle_percent + "%" : "N/A"}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Measurement</span>
                                    <span class="aqcstone-rs-value">${s1.measurements}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    } else {
        const stock_num = stone["stock_num"];
        const stock_id = stone["id"];
        const vendor_id = formatValue(stone["vendor_id"]);
        const lab = formatValue(stone["lab"]);
        const shape = formatValue(stone["shape"]);
        const size = formatSize(stone["size"]);
        const clarity = formatValue(stone["clarity"]);
        const cut = formatValue(stone["cut"],'-');
        const image_url = vdbrcResolveStoneImageUrl(formatValue(stone["image_url"]));
        const color = formatValue(stone["color"]);
        const polish = formatValue(stone["polish"]);
        const symmetry = formatValue(stone["symmetry"]);
        const depth_per = formatValue(stone["depth_percent"]);
        const table_per = formatValue(stone["table_percent"]);
        const video_url = formatValue(stone["video_url"]);
        const cert_url = formatValue(stone["cert_url"]);
        const video_type = formatValue(stone["video_type"]);
        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
        const meas_ratio = formatValue(stone["meas_ratio"]);
        const girdle_condition = formatValue(stone["girdle_condition"]);
        const girdle_percent = formatValue(stone["girdle_percent"]);
        const total_sales_price = stone["total_sales_price"];
        const long_title = formatValue(stone["long_title"]);

        const measurements_arr = [
            formatValue(stone["meas_length"], "0.00"), formatValue(stone["meas_width"], "0.00"), formatValue(stone["meas_depth"], "0.00"),
        ];
        const measurements = measurements_arr.every((element) => element === "0.00") ? "-" : measurements_arr.join(" x ");

        var price = handlePriceData(stone_currency_code, total_sales_price);

        let shape_icon_url = "";
        const shapeElement = $(`.vdbrc_stone_shape[data-value="${shape}"]`);
        if (shapeElement.length) {
            shape_icon_url = shapeElement.attr("data-icon-url");
        }

        let videoHtml = "";
        if(video_url != "" && video_url != null) {
            if (video_type == 'native') {
                videoHtml = `<video class="vdb_stone_video" src="" controls controlsList="nodownload" data-src="${video_url}" style="display: none"></video>'`;
            } else {
                videoHtml = `<iframe class="vdb_stone_video" allow="autoplay" src="" frameborder="0" data-src="${video_url}" style="display: none"></iframe>`;
            }
        }

        const activeClass = isCompared ? 'aqcstone-active' : '';

        const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
        const stockParamKey = vdbrcStoneTab === "natural" ? "natural_stock_num" : "labgrown_stock_num";

        const currentParams = new URLSearchParams(window.location.search);
        const refCollection = currentParams.get('ref_collection');
        const shapeVal = currentParams.get('shape');
        const flowVal = currentParams.get('flow');

        const params = new URLSearchParams({
            [stockParamKey]: stock_num,
            vendor_id: vendor_id,
            ...(isRingSelected === true ? { 'ring-handle': ringHandle } : {}),
            ...(refCollection ? { ref_collection: refCollection } : {}),
            ...(shapeVal ? { shape: shapeVal } : {}),
            ...(flowVal ? { flow: flowVal } : {})
        });

        const completeUrl = vdbrcStoneCompleteUrl(params, `/products/stone?${params.toString()}`);

        const name = long_title || `${shape} ${size} ${color} ${clarity}`;
        const displayName = `${size} carat ${shape} <span>${color} ${clarity} Lab</span>`;

        const uncertifiedLab = window.vdbrcIsUncertifiedLab && window.vdbrcIsUncertifiedLab(lab);
        const reportIcon = cert_url && !uncertifiedLab
        ? '<i class="ph ph-arrow-square-out" style="font-size:12px;color:#666;"></i>'
        : '';
        
        return `
            <div class="aqcstone-list-item vdbrc_list_row_tr" data-stock-num="${stock_num}" data-stock-id="${stock_id}" data-video-url="${video_url}" data-image-url="${image_url}">
                <div class="aqcstone-list-row vdbrc_stone_list_row">
                    <div class="aqcstone-list-cell" data-label="Shape">
                        <img src="${shape_icon_url}" style="width: 40px; height: 40px; margin-right: 8px;">
                        ${shape}
                    </div> 

                    <div class="aqcstone-list-cell aqcstone-list-price" data-label="Price">
                        ${price}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Carat">
                        ${size}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Cut">
                        ${cut}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Color">
                        ${color}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Ratio">
                        ${meas_ratio}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Clarity">
                        ${clarity}
                    </div>

                    <div class="aqcstone-list-cell" data-label="Measurement">
                        ${measurements}
                    </div>

                    <!--<div class="aqcstone-list-cell" data-label="Girdle">
                        ${girdle_condition}
                    </div>-->

                    <div class="aqcstone-list-cell vdbrc_stone_list_report" data-label="Report" data-report-url="${uncertifiedLab ? '' : cert_url}" >
                        ${lab} ${reportIcon}
                    </div>
                    <div class="aqcstone-list-cell aqcstone-list-compare vdbrc_stone_compare_btn ${activeClass}" data-label="Compare">
                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/352c2594416ccbda6917b9987721446b237db0e0.svg?v=1774375047" alt="Wishlist" style="width: 20px;" />
                        <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/compare-active.png?v=1767724339" alt="Wishlist" />
                    </div>
                </div>
                <div class="aqcstone-list-detail vdbrc_stone_list_detail">
                    <div class="aqcstone-detail-container">
                        <!-- Left Image -->
                        <div class="aqcstone-detail-left">
                            <div class="aqcstone-detail-image-box">
                                <div class="vdbrc_thumbnail_container">
                                    <img src="${image_url}" data-src="${image_url}" onerror="this.onerror=null;this.src='${no_image_url}';" alt="Diamond" class="aqcstone-detail-main-img">
                                    ${videoHtml}
                                </div>
                                <button class="aqcstone-play-btn vdbrc_stone_video_btn" data-video-url="${video_url}" data-img-src="${image_url}">
                                    <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/play-icon-list.png?v=1768510102" alt="Play">
                                    <img class="image-icon" src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/display-image-icon.png?v=1786042642" alt="display Image" style="display:none;">
                                </button>
                                <button class="aqcstone-zoom-btn vdbrc_stone_quick_view" data-stock-id="${stock_id}"><img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/search-icon-list.png?v=1768510103" alt="Zoom" ></button>
                            </div>
                        </div>
                        <!-- Center Content -->
                        <div class="aqcstone-detail-center">
                            <h3 class="aqcstone-detail-heading">${displayName}</h3>
                            <div class="aqcstone-detail-price-large">${price}</div>

                            <div class="aqcstone-detail-grid-box">
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${size}</span>
                                    <span class="aqcstone-box-label">CARAT</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${color}</span>
                                    <span class="aqcstone-box-label">COLOR</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${clarity}</span>
                                    <span class="aqcstone-box-label">CLARITY</span>
                                </div>
                                <div class="aqcstone-grid-box-item">
                                    <span class="aqcstone-box-value">${cut}</span>
                                    <span class="aqcstone-box-label">CUT</span>
                                </div>
                            </div>

                            <div class="aqcstone-detail-action-col">
                                <button class="aqcstone-btn-outline vdbrc_view_stone_detail" data-url="/products/stone?${params.toString()}">VIEW DETAILS <i class="ph ph-arrow-right"></i></button>
                                <button class="aqcstone-btn-primary vdbrc_complete_my_ring_btn${isRingSelected ? '' : ' d-none'}" data-stock-num="${stock_num}" data-stock-key="${stockParamKey}" data-vendor-id="${vendor_id}" data-url="${completeUrl}">
                                    <i class="ph ph-diamond"></i> ${isRingSelected ? 'SELECT STONE' : 'COMPLETE MY RING'} <i class="ph ph-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                        <!-- Right Specs -->
                        <div class="aqcstone-detail-right">
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Cut</span>
                                    <span class="aqcstone-rs-value">${cut}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Girdle Thickness</span>
                                    <span class="aqcstone-rs-value">${girdle_condition}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Symmetry</span>
                                    <span class="aqcstone-rs-value">${symmetry}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Table</span>
                                    <span class="aqcstone-rs-value">${table_per && table_per != '' ? table_per + '%' : 'N/A'}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Polish</span>
                                    <span class="aqcstone-rs-value">${polish}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Depth</span>
                                    <span class="aqcstone-rs-value">${depth_per && depth_per != '' ? depth_per + '%' : 'N/A'}</span>
                                </div>
                            </div>
                            <div class="aqcstone-spec-row">
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Girdle Percentage</span>
                                    <span class="aqcstone-rs-value">${girdle_percent && girdle_percent != '' ? girdle_percent + '%' : 'N/A'}</span>
                                </div>
                                <div class="aqcstone-right-spec">
                                    <span class="aqcstone-rs-label">Measurement</span>
                                    <span class="aqcstone-rs-value">${measurements}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
//#endregion

//#region : Quick View + Add to Cart Logic
$('body').on('click', '.vdbrc_add_to_cart_btn', async function () {
    const _this = this;
    const stockNum = $(this).data('stone-stock-num');
    const stockId = $(this).data('stone-stock-id');
    const price = $(this).data('stone-price');
    const image = $(this).data('stone-image');
    const title = $(this).data('stone-title');

    const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
    const stockParamKey = vdbrcStoneTab === "natural" ? "natural_stock_num" : "labgrown_stock_num";

    if (stockNum && stockId) {
        addStoneToCart(_this, stockParamKey, stockNum, stockId, price, image, title);
    }
});

async function addStoneToCart(atcElement, stockNumKey, stockNum, stockId, price, image, title) {
    const sendData = new URLSearchParams();
    sendData.append("action", "add_product_info");
    sendData.append("shop", shop);
    sendData.append(stockNumKey, stockNum);
    sendData.append("stock_id", stockId);
    sendData.append("product_price", price);
    sendData.append("prod_img", image);
    sendData.append("product_title", title);

    atcElement.disabled = true;
    atcElement.style.pointerEvents = "none";
    atcElement.style.opacity = "0.6";

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);

                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        if (!responseData || !responseData.success || !responseData.data || !responseData.data.var_id) {
            alert('Failed to prepare stone variant. Please try again.');
            return;
        }
        const variantId = responseData.data.var_id;

        if (typeof vdbrcCartContainsVariant === 'function' && await vdbrcCartContainsVariant(variantId)) {
            if (isRedirectToCartPage) {
                window.location.href = '/cart';
            } else {
                await vdbrcOpenUpdatedCartDrawer();
            }
            return;
        }

        await shopifyAddToCart(variantId, 1, {
            "Stock ID": stockId,
            "Stock Number": stockNum
        });

        if (isRedirectToCartPage) {
            window.location.href = '/cart';
        } else {
            await vdbrcOpenUpdatedCartDrawer();
        }
    } catch (error) {
        console.error("Error adding stone to cart:", error);
        alert(error?.message || 'An error occurred while adding the stone to cart. Please try again.');
    } finally {
        atcElement.disabled = false;
        atcElement.style.pointerEvents = "auto";
        atcElement.style.opacity = "1";
    }
}

async function shopifyAddToCart(variantId, qty = 1, properties = null) {
    const payload = {
        id: Number(variantId),
        quantity: qty
    };

    // Optional: line item properties (shows under item in cart)
    if (properties && typeof properties === "object") {
        payload.properties = properties;
    }

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    // Shopify returns 200 + JSON on success, 4xx + JSON on error
    const data = await res.json().catch(() => null);

    if (!res.ok) {
        const msg = (data && (data.description || data.message)) || 'Shopify cart add failed';
        throw new Error(msg);
    }

    return data; // contains added line item object
}
//#endregion

//#region : Stone Compare Logic
function toggleCompare(stoneId) {
    const index = comparedStones.findIndex(s => s.id === stoneId);

    if (index > -1) {
        // Remove
        comparedStones.splice(index, 1);

        // Update styling in main list
        updateCompareButtonState(stoneId, false);
    } else {
        // Add
        const stone = stoneMap[stoneId];
        if (stone) {
            comparedStones.push(stone);
            updateCompareButtonState(stoneId, true);
        }
    }

    updateCompareView();
}

function updateCompareButtonState(stoneId, isCompared) {
    // Find all buttons for this stone (grid/list/compare tabs)
    const btns = $(`.vdbrc_stone_compare_btn`).closest(`[data-stock-id="${stoneId}"]`).find('.vdbrc_stone_compare_btn');

    if (isCompared) {
        btns.addClass('aqcstone-active');
    } else {
        btns.removeClass('aqcstone-active');
    }
}

function updateCompareView() {
    // Update Count
    $('.vdbrc_stone_compare_count').text(comparedStones.length);

    comparedStones.length > 0 ? $('.vdbrc_stone_filter_header .vdbrc_view_tab[data-view="stone_compare"]').addClass('stone_compare_active') : $('.vdbrc_stone_filter_header .vdbrc_view_tab[data-view="stone_compare"]').removeClass('stone_compare_active');

    const compareGridContainer = $('#vdbrc_compare_grid_view_container');
    const compareListBody = $('#vdbrc_compare_list_view_body');
    const emptyState = $('#vdbrc_compare_empty_state');

    // Clear Content
    compareGridContainer.empty();
    compareListBody.empty();

    if (comparedStones.length === 0) {
        emptyState.show();
        $('.vdbrc_stone_list_header', '#vdbrc_compare_list_view_container').hide();
    } else {
        emptyState.hide();
        $('.vdbrc_stone_list_header', '#vdbrc_compare_list_view_container').show();

        let gridHtml = "";
        let listHtml = "";

        // Reverse order to show newest added first? Or keep selection order.
        // User said "displayed exactly the same way". Usually insertion order.
        comparedStones.forEach(stone => {
            gridHtml += getStoneGridHtml(stone, true);
            listHtml += getStoneListHtml(stone, true);
        });

        compareGridContainer.html(gridHtml);
        compareListBody.html(listHtml);

        // Show the missing-image graphic only after a compare thumbnail actually fails.
        $("#vdbrc_compare_grid_view_container img.vdbrc_stone_grid_thumbnail")
            .off('error.vdbrcCompare')
            .on('error.vdbrcCompare', function () {
                this.onerror = null;
                this.src = no_image_url;
                vdbrcSetStoneThumbnailLoading($(this), false);
            });

        // Lazy load logic for Compare Grid
        if (getCookie("vdbrc_stone_tab_view") === "grid_view") {
            vdbrcLoadVisibleStoneThumbnails("#vdbrc_compare_grid_view_container");
        }
    }
}

// Compare Event Listeners
$('body').on('click', '.vdbrc_stone_compare_btn', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const container = $(this).closest('[data-stock-id]');
    const stoneId = container.data('stock-id');

    if (stoneId) {
        toggleCompare(stoneId);
    }
});
//#endregion

$('body').on('click', '.vdbrc_view_stone_detail, .vdbrc_grid_row_tr', function () {
    const url = $(this).data('url');
    if (url) {
        window.location.href = url;
    }
});

// Builds the review URL for a stone card, so each card points at its own stone
// instead of whatever stone the page URL was opened with.
function vdbrcStoneCompleteUrl(stoneParams, fallbackUrl) {
    if (isRingSelected !== true || !ringHandle) return fallbackUrl;

    const completeParams = new URLSearchParams(stoneParams.toString());
    completeParams.set('ring-handle', ringHandle);
    completeParams.set('steps', 'settings');
    completeParams.set('review', 'true');
    completeParams.delete('change_flow');

    return `/products/${ringHandle}?${completeParams.toString()}`;
}

// Mirrors the Stone PDP: with no setting chosen yet, the primary CTA sends the
// stone into the settings collection, pre-filtered to its shape.
function vdbrcStoneSettingsUrl(stoneParams, shape) {
    const settingParams = vdbrcDedupeParams(new URLSearchParams(stoneParams.toString()));
    if (shape) {
        settingParams.set('shape', shape);
        settingParams.set('filter.p.m.custom.shape', shape);
    }
    settingParams.delete('change_flow');

    return vdbrcBuildUrl(`/collections/${collectionHandleDefault}`, settingParams);
}

$('body').on('click', '.vdbrc_complete_my_ring_btn', function () {
    const url = $(this).data('url');
    if (!url) return;

    const stockNum = $(this).data('stock-num');
    const stockKey = $(this).data('stock-key');
    const vendorId = $(this).data('vendor-id');

    const target = new URL(url, window.location.origin);

    if (stockNum && stockKey) {
        target.searchParams.delete('labgrown_stock_num');
        target.searchParams.delete('natural_stock_num');
        target.searchParams.delete('stone-stock');
        target.searchParams.set(stockKey, stockNum);
        target.searchParams.set('type', stockKey === 'natural_stock_num' ? 'natural' : 'labgrown');
    }

    if (vendorId) target.searchParams.set('vendor_id', vendorId);

    window.location.href = target.toString();
});

$('body').on('click', '.vdbrc_certificate_url', function () {
    const url = $(this).data('cert-url');
    if (url) {
        window.open(url, '_blank');
    }
});

//#region : General Functions
function handlePriceData(stoneCurrencyCode, total_sales_price, withoutFormate = false) {
    // Helper function to check if a value is defined and not empty
    function isValidCurrency(currency) {
        return currency !== undefined && currency !== null && currency !== "";
    }
    // Initial price conversion to shop currency
    let price = Math.round(price_in_shop_currency(total_sales_price));
    if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
        if (stoneCurrencyCode !== shop_currency) {
            // Convert to USD first, then to shop currency
            let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
            price = Math.round(price_in_shop_currency(usd_price));
        } else {
            price = Math.round(total_sales_price);
        }
    }
    if (withoutFormate) {
        price = Math.round(total_sales_price);
    } else {
        price = vdbrcFormatMoney(price * 100, moneyFormat);
    }
    // Convert price to market currency if different from shop currency
    if (market_currency !== shop_currency) {
        price = Math.round(price_in_market_currency(total_sales_price));
        if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
            if (stoneCurrencyCode !== market_currency) {
                // Convert to USD first, then to market currency
                let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
                price = Math.round(price_in_market_currency(usd_price));
            } else {
                price = Math.round(total_sales_price);
            }
        }
        if (withoutFormate) {
            price = Math.round(total_sales_price);
        } else {
            price = vdbrcFormatMoney(price * 100, market_currency_symbol + " {amount}");
        }
    }
    return price;
}
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}
function updateUrl(url, key, value) {
    if (value !== undefined) {
        value = encodeURI(value);
    }
    var hashIndex = url.indexOf("#") | 0;
    if (hashIndex === -1) hashIndex = url.length | 0;
    var urls = url.substring(0, hashIndex).split("?");
    var baseUrl = urls[0];
    var parameters = "";
    var outPara = {};
    if (urls.length > 1) {
        parameters = urls[1];
    }
    if (parameters !== "") {
        parameters = parameters.split("&");
        for (k in parameters) {
            var keyVal = parameters[k];
            keyVal = keyVal.split("=");
            var ekey = keyVal[0];
            var evalue = "";
            if (keyVal.length > 1) {
                evalue = keyVal[1];
            }
            outPara[ekey] = evalue;
        }
    }
    if (value !== undefined) {
        outPara[key] = value;
    } else {
        delete outPara[key];
    }
    parameters = [];
    for (var k in outPara) {
        parameters.push(k + "=" + outPara[k]);
    }
    var finalUrl = baseUrl;
    if (parameters.length > 0) {
        finalUrl += "?" + parameters.join("&");
    }
    return finalUrl + url.substring(hashIndex);
}
function resetDeepLink(keepParams = ['ring-handle', 'ref_collection', 'show_match_stone_pair']) {
    const url = new URL(window.top.location.href);
    const searchParams = new URLSearchParams(url.search);

    // Remove everything except allowed params
    for (const key of Array.from(searchParams.keys())) {
        if (!keepParams.includes(key)) {
            searchParams.delete(key);
        }
    }

    const newQuery = searchParams.toString();
    const newUrl = url.pathname + (newQuery ? `?${newQuery}` : '') + url.hash;

    window.top.history.pushState({}, '', newUrl);
}
function removeURLParameters(url, ...parameters) {
    const parsed = new URL(url);
    parameters.forEach(e => parsed.searchParams.delete(e))
    return parsed.toString()
}
$('body').on('click', '.vdbrc_stone_quick_view', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const stoneId = $(this).data('stock-id');
    if (stoneId) {
        openQuickViewModal(stoneId);
    }
});

function openQuickViewModal(stoneId) {
    const stone = stoneMap[stoneId];
    if (!stone) return;

    const modal = $('#vdbrc_quick_view_modal');
    if (!modal.length) return;

    const html = getQuickViewHtml(stone);

    modal.find('.aqcstone-modal-content').html(html);
    if (window.vdbrcSyncLabCertificate) {
        window.vdbrcSyncLabCertificate(formatValue(stone["lab"]), formatValue(stone["cert_url"]), modal);
    }
    modal.addClass('aqcstone-modal-show');
    $('body').addClass('aqcstone-no-scroll');
}

$('body').on('click', '.vdbrc_close_quick_view, .aqcstone-modal-overlay', function () {
    closeQuickViewModal();
});

function closeQuickViewModal() {
    $('#vdbrc_quick_view_modal').removeClass('aqcstone-modal-show');
    $('body').removeClass('aqcstone-no-scroll');
}

function getQuickViewHtml(stone) {
    const stock_num = stone["stock_num"];
    const stock_id = stone["id"];
    const vendor_id = formatValue(stone["vendor_id"]);
    const shape = formatValue(stone["shape"]);
    const size = formatSize(stone["size"]);
    const clarity = formatValue(stone["clarity"]);
    const cut = formatValue(stone["cut"],'-');
    const color = formatValue(stone["color"], "-");
    const image_url = vdbrcResolveStoneImageUrl(formatValue(stone["image_url"]));
    const video_url = formatValue(stone["video_url"]);
    const video_type = formatValue(stone["video_type"]);
    const cert_url = formatValue(stone["cert_url"]);
    const lab = formatValue(stone["lab"]);
    const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
    const total_sales_price = stone["total_sales_price"];
    const long_title = formatValue(stone["long_title"]);
    const symmetry = formatValue(stone["symmetry"]);
    const polish = formatValue(stone["polish"]);
    const meas_length = formatValue(stone["meas_length"], "0.00");
    const meas_width = formatValue(stone["meas_width"], "0.00");
    const meas_depth = formatValue(stone["meas_depth"], "0.00");

    const vdbrcStoneTab = getCookie('vdbrc_stone_tab') || STONE_TYPES[0];
    const stockParamKey = vdbrcStoneTab === "natural" ? "natural_stock_num" : "labgrown_stock_num";
    const stoneOrigin = stockParamKey === 'labgrown_stock_num' ? "Lab Grown" : "Natural";
    const currentParams = new URLSearchParams(window.location.search);
    const refCollection = currentParams.get('ref_collection');
    const shapeVal = currentParams.get('shape');
    let flowVal = currentParams.get('flow') || '';
    if (!flowVal) {
        try {
            flowVal = sessionStorage.getItem('vdbrc_flow') || '';
        } catch (e) {
            flowVal = '';
        }
    }
    if (flowVal !== 'diamond' && flowVal !== 'setting') flowVal = '';

    const detailParams = new URLSearchParams({
        [stockParamKey]: stock_num,
        vendor_id: vendor_id,
        ...(isRingSelected === true ? { 'ring-handle': ringHandle } : {}),
        ...(refCollection ? { ref_collection: refCollection } : {}),
        ...(shapeVal ? { shape: shapeVal } : {}),
        ...(flowVal ? { flow: flowVal } : {})
    });
    const detailUrl = `/products/stone?${detailParams.toString()}`;
    const completeUrl = vdbrcStoneCompleteUrl(detailParams, vdbrcStoneSettingsUrl(detailParams, shape));

    var price = handlePriceData(stone_currency_code, total_sales_price);
    const displayName = `${size} Carat ${shape} ${stoneOrigin} Diamond`;

    let videoHtml = "";
    if (video_url) {
        if (video_type === 'native') {
            videoHtml = `<video class="vdb_stone_video" src="${video_url}" controls controlsList="nodownload" data-src="${video_url}"></video>`;
        } else {
            videoHtml = `<iframe class="vdb_stone_video" allow="autoplay" src="${video_url}" frameborder="0" data-src="${video_url}"></iframe>`;
        }
    }

    return `
        <div class="stonepdp-container aqcstone-quick-view-modal-content" style="padding: 12px;  margin: 0 auto; background: #fff; position: relative; border-radius: 20px;">
            <button class="aqcstone-modal-close vdbrc_close_quick_view" 
                style="position: absolute; top: 20px; right: 20px; z-index: 100;
                background: #fff;
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
                
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.3335 3.33325L12.6668 12.6666" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M12.6668 3.33325L3.3335 12.6666" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </button>
            <div class="stonepdp-main-wrapper" style="display: flex; gap: 30px; flex-direction: row; align-items: flex-start;">
                <!-- Image Section -->
                <div class="stonepdp-gallery-section" style="width: 55%; display: block;">
                    <div class="stonepdp-gallery-grid" style="display: block;">
                        <div class="stonepdp-gallery-item stonepdp-gallery-item-main" style="min-height: auto; aspect-ratio: 1/1; border: none; background: #F2F4F7; border-radius: 16px; display: flex; align-items: center; justify-content: center; padding: 0px;">
                            ${videoHtml !== "" 
                                ? videoHtml 
                                : `<img src="${image_url}" onerror="this.src='${no_image_url}';" class="stonepdp-gallery-image" style="max-width: 100%; max-height: 100%; object-fit: contain;" alt="${long_title}" />`
                            }
                            <div class="stonepdp-tag-wrapper stonepdp-tag-top-left d-none" style="top: 20px; left: 20px;">
                                <span class="stonepdp-tag">Best Seller</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Info Section -->
                <div class="stonepdp-product-info" style="padding: 39px 0; width: 45%; max-width: none; display: flex; flex-direction: column; gap: 20px;">
                    <div class="stonepdp-header-section" style="gap: 12px; display: flex; flex-direction: column;">
                        <h1 class="stonepdp-product-title" style="margin: 0; font-size: 28px;">${displayName}</h1>
                        <div class="stonepdp-price-wrapper" style="display: flex; flex-direction: column;">
                            <span class="stonepdp-price-main" style="font-size: 32px;">${price}</span>
                            <span class="stonepdp-price-setting d-none">With Setting: $2,642</span>
                        </div>
                        
                        <!-- Attributes Grid -->
                        <div class="stonepdp-attributes-grid" style="margin-top: 10px;">
                            <div class="stonepdp-attributes-row stonepdp-attributes-row-bordered" style="border-bottom: 1px solid #E3EEF5; display: flex;">
                                <div class="stonepdp-attribute-cell" style="flex: 1; text-align: center; padding: 10px 5px;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${size}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Carat</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${clarity}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Clarity</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${color}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Color</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${cut}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Cut</p>
                                </div>
                            </div>
                            <div class="stonepdp-attributes-row" style="display: flex;">
                                <div class="stonepdp-attribute-cell" style="flex: 1; text-align: center; padding: 10px 5px;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${stoneOrigin}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Origin</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${shape}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Shape</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${polish}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">Polish</p>
                                </div>
                                <div class="stonepdp-attribute-cell stonepdp-attribute-cell-bordered" style="flex: 1; text-align: center; padding: 10px 5px; border-left: 1px solid #E5E5E5;">
                                    <p class="stonepdp-attribute-value" style="margin: 0;">${meas_length} x ${meas_width}</p>
                                    <p class="stonepdp-attribute-label" style="margin: 4px 0 0;">L/W (mm)</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CTA Buttons -->
                    <div class="stonepdp-cta-section" style="margin-top: 10px; display: flex; flex-direction: column; gap: 12px;">
                        <button class="stonepdp-btn-primary stonepdp-btn-full vdbrc_complete_my_ring_btn" data-stock-num="${stock_num}" data-stock-key="${stockParamKey}" data-vendor-id="${vendor_id}" data-url="${completeUrl}" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 12px; padding: 16px; border-radius: 12px;">
                             <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/32a3eb84a71d2acf40e484d10f118a1258a7e2d7.svg?v=1774375084" />
                            <span>${isRingSelected ? 'Select Stone' : 'Select A Stone'}</span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.66683 12L12.6668 8L8.66683 4M12.3335 8H3.3335" stroke="white" stroke-width="1.25" stroke-linecap="square"/>
                            </svg>
                        </button>
                        ${isRingSelected ? '' : `<button class="stonepdp-btn-secondary stonepdp-btn-full vdbrc_add_to_cart_btn" 
                                style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 12px; padding: 16px; border-radius: 12px;"
                                data-stone-stock-num="${stock_num}" 
                                data-stone-stock-id="${stock_id}" 
                                data-stone-price="${total_sales_price}" 
                                data-stone-image="${image_url}" 
                                data-stone-title="${displayName}">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/9b22f92fe296485b8b1a9a6c6f5702e5e7c65a5c.svg?v=1774375125" />
                            <span>Add to cart</span>
                        </button>`}
                    </div>

                    <!-- Trust Indicators -->
                    <div class="stonepdp-trust-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-top: 15px;">
                        <div class="stonepdp-trust-item" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 8px;">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/17e8c9f5c34b316e19e419987d77ffdfb61ee488.svg?v=1774375166" style="width: 24px;" />
                            <p class="stonepdp-trust-text">Fast<br>Shipping</p>
                        </div>
                        <div class="stonepdp-trust-item" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 8px;">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/d6ba2381255b9c82cea699f926bcc2c1fc3c03fd.svg?v=1774375197" style="width: 24px;" />
                            <p class="stonepdp-trust-text">Lifetime<br>Warranty</p>
                        </div>
                        <div class="stonepdp-trust-item" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 8px;">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/52633a7763feeef3533528ae2029c9ca309f88b8.svg?v=1774375228" style="width: 24px;" />
                            <p class="stonepdp-trust-text">30 Days<br>Free Return</p>
                        </div>
                        <div class="stonepdp-trust-item" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 8px;">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/1d59e8a950a8d0bcb50333118596f207cd68e408.svg?v=1774375257" style="width: 24px;" />
                            <p class="stonepdp-trust-text">Certificate<br>& Appraisal</p>
                        </div>
                    </div>

                    <!-- Certificate Banner -->
                    <div class="stonepdp-cert-banner" style="display: flex !important; background: #FCF9F0; border: 1px solid #EFE4CC; border-radius: 12px; padding: 12px; align-items: center; gap: 12px; margin-top: 15px;">
                        <div class="stonepdp-cert-banner-left" style="display: flex; align-items: center; gap: 12px; flex: 1;">
                            <img class="stonepdp-cert-banner-icon vdbrc_lab_cert_image" src="${window.vdbrcLabCertImage ? window.vdbrcLabCertImage(lab) : ''}" alt="" width="32" height="32" style="width: 32px; height: 32px;" />
                            <div class="stonepdp-cert-banner-content">
                                <span class="stonepdp-cert-banner-title" style="display: block; font-size: 12px; font-weight: 600;">${window.vdbrcIsUncertifiedLab && window.vdbrcIsUncertifiedLab(lab) ? 'Non-Certified' : lab} - ${stoneOrigin} Diamond</span>
                                <a href="${cert_url}" target="_blank" class="stonepdp-cert-banner-link" style="font-size: 11px; text-decoration: underline; display: flex; align-items: center; gap: 4px;">
                                    Click to View Certificate 
                                    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 10px; height: 10px;">
                                        <path d="M2.5 7.5L7.5 2.5" stroke="currentColor" stroke-linecap="square"/>
                                        <path d="M3.3335 2.5H7.50016V6.66667" stroke="currentColor" stroke-linecap="square"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                        <div class="stonepdp-cert-banner-right vdbrc_certificate_url" data-cert-url="${cert_url}" style="cursor: pointer;">
                            <img src="https://cdn.shopify.com/s/files/1/0755/7854/0322/files/redirect_newtab.png?v=1767732361" border="0" style="width: 16px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}
//#endregion